"use client";
import React from "react";
import * as _Builtin from "./_Builtin";
import * as _interactions from "./interactions";
import { ForEngineersElevateCareer } from "./ForEngineersElevateCareer";
import * as _utils from "./utils";
import _styles from "./ForEngineersContent.module.css";

const _interactionsData = JSON.parse(
  '{"events":{"e-735":{"id":"e-735","name":"","animationType":"custom","eventTypeId":"MOUSE_CLICK","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-265","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-736"}},"mediaQueries":["main","medium","small","tiny"],"target":{"selector":".combine-faq1_question","originalId":"6347c2441fb34299acfdf2d9|f3e8fb86-0f31-c422-7473-c92bd02979e3","appliesTo":"CLASS"},"targets":[{"selector":".combine-faq1_question","originalId":"6347c2441fb34299acfdf2d9|f3e8fb86-0f31-c422-7473-c92bd02979e3","appliesTo":"CLASS"}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1663928427350},"e-736":{"id":"e-736","name":"","animationType":"custom","eventTypeId":"MOUSE_SECOND_CLICK","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-266","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-735"}},"mediaQueries":["main","medium","small","tiny"],"target":{"selector":".combine-faq1_question","originalId":"6347c2441fb34299acfdf2d9|f3e8fb86-0f31-c422-7473-c92bd02979e3","appliesTo":"CLASS"},"targets":[{"selector":".combine-faq1_question","originalId":"6347c2441fb34299acfdf2d9|f3e8fb86-0f31-c422-7473-c92bd02979e3","appliesTo":"CLASS"}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1663928427351}},"actionLists":{"a-265":{"id":"a-265","title":"faq1_question Reveal","actionItemGroups":[{"actionItems":[{"id":"a-265-n","actionTypeId":"TRANSFORM_ROTATE","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".combine-faq1_expander","selectorGuids":["86ef42b2-207c-03cf-4bc8-e931ac22f108"]},"zValue":0,"xUnit":"DEG","yUnit":"DEG","zUnit":"deg"}},{"id":"a-265-n-2","actionTypeId":"STYLE_SIZE","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":"SIBLINGS","selector":".combine-faq1_answer","selectorGuids":["86ef42b2-207c-03cf-4bc8-e931ac22f104"]},"heightValue":0,"widthUnit":"PX","heightUnit":"px","locked":false}},{"id":"a-265-n-3","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"useEventTarget":"SIBLINGS","selector":".combine-faq1_answer","selectorGuids":["86ef42b2-207c-03cf-4bc8-e931ac22f104"]},"value":"none"}}]},{"actionItems":[{"id":"a-265-n-4","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"useEventTarget":"SIBLINGS","selector":".combine-faq1_answer","selectorGuids":["86ef42b2-207c-03cf-4bc8-e931ac22f104"]},"value":"block"}}]},{"actionItems":[{"id":"a-265-n-5","actionTypeId":"TRANSFORM_ROTATE","config":{"delay":0,"easing":"ease","duration":250,"target":{"useEventTarget":"CHILDREN","selector":".combine-faq1_expander","selectorGuids":["86ef42b2-207c-03cf-4bc8-e931ac22f108"]},"zValue":45,"xUnit":"DEG","yUnit":"DEG","zUnit":"deg"}},{"id":"a-265-n-6","actionTypeId":"STYLE_SIZE","config":{"delay":0,"easing":"ease","duration":250,"target":{"useEventTarget":"SIBLINGS","selector":".combine-faq1_answer","selectorGuids":["86ef42b2-207c-03cf-4bc8-e931ac22f104"]},"widthUnit":"PX","heightUnit":"AUTO","locked":false}}]}],"useFirstGroupAsInitialState":true,"createdOn":1663928430946},"a-266":{"id":"a-266","title":"faq1_question Hide","actionItemGroups":[{"actionItems":[{"id":"a-266-n","actionTypeId":"TRANSFORM_ROTATE","config":{"delay":0,"easing":"ease","duration":250,"target":{"useEventTarget":"CHILDREN","selector":".combine-faq1_expander","selectorGuids":["86ef42b2-207c-03cf-4bc8-e931ac22f108"]},"zValue":0,"xUnit":"DEG","yUnit":"DEG","zUnit":"deg"}},{"id":"a-266-n-2","actionTypeId":"STYLE_SIZE","config":{"delay":0,"easing":"ease","duration":250,"target":{"useEventTarget":"SIBLINGS","selector":".combine-faq1_answer","selectorGuids":["86ef42b2-207c-03cf-4bc8-e931ac22f104"]},"heightValue":0,"widthUnit":"PX","heightUnit":"px","locked":false}}]},{"actionItems":[{"id":"a-266-n-3","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"useEventTarget":"SIBLINGS","selector":".combine-faq1_answer","selectorGuids":["86ef42b2-207c-03cf-4bc8-e931ac22f104"]},"value":"none"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1663928740230}},"site":{"mediaQueries":[{"key":"main","min":992,"max":10000},{"key":"medium","min":768,"max":991},{"key":"small","min":480,"max":767},{"key":"tiny","min":0,"max":479}]}}'
);

export function ForEngineersContent({
  as: _Component = _Builtin.Block,
  combineClients4Grid2Slot,
  richQuote = {},
  name = {},
  role = {},
}) {
  _interactions.useInteractions(_interactionsData, _styles);

  return (
    <_Component tag="div">
      <_Builtin.Block
        className={_utils.cx(_styles, "combine-section_header4", "engineers")}
        tag="section"
      >
        <_Builtin.Block
          className={_utils.cx(_styles, "combine-padding-global-3")}
          tag="div"
        >
          <_Builtin.Block
            className={_utils.cx(_styles, "combine-container-small-2")}
            tag="div"
          >
            <_Builtin.Block
              className={_utils.cx(_styles, "combine-padding-section-large")}
              tag="div"
            >
              <_Builtin.Block
                className={_utils.cx(_styles, "combine-text-align-center-2")}
                tag="div"
              >
                <_Builtin.Heading
                  className={_utils.cx(_styles, "combine-heading-style-h1-2")}
                  tag="h1"
                >
                  <_Builtin.Strong>
                    {"Get Paid "}
                    <_Builtin.Emphasized
                      className={_utils.cx(_styles, "italic-text-13")}
                    >
                      {"On-Time"}
                    </_Builtin.Emphasized>
                    {" For Your"}
                    <br />
                    {" Audio Engineering Services."}
                  </_Builtin.Strong>
                </_Builtin.Heading>
                <_Builtin.Block
                  className={_utils.cx(_styles, "combine-space-medium-2")}
                  tag="div"
                />
                <_Builtin.Block
                  className={_utils.cx(_styles, "combine-text-size-regular-4")}
                  tag="div"
                >
                  {
                    "Host your Recording, Mixing, Mastering, and Dolby Atmos Services while taking advantage of our tailored project management tools designed to streamline Client Bookings, Project Files Transfer, Revisions, Payment and More!"
                  }
                </_Builtin.Block>
                <_Builtin.Block
                  className={_utils.cx(_styles, "combine-space-medium-2")}
                  tag="div"
                />
                <_Builtin.Block
                  className={_utils.cx(_styles, "combine-button-wrapper-3")}
                  tag="div"
                >
                  <_Builtin.Link
                    className={_utils.cx(_styles, "engineears-button")}
                    button={true}
                    block=""
                    options={{
                      href: "https://engineears.com/signup?flow=6&step=3",
                    }}
                  >
                    {"Get Started"}
                  </_Builtin.Link>
                </_Builtin.Block>
              </_Builtin.Block>
            </_Builtin.Block>
          </_Builtin.Block>
        </_Builtin.Block>
      </_Builtin.Block>
      <_Builtin.Section
        className={_utils.cx(_styles, "homepage-section")}
        grid={{
          type: "section",
        }}
        tag="section"
      >
        <_Builtin.BlockContainer
          className={_utils.cx(_styles, "homepage-container")}
          grid={{
            type: "container",
          }}
          tag="div"
        >
          <_Builtin.Block
            className={_utils.cx(_styles, "homepage-header-wrapper")}
            tag="div"
          >
            <_Builtin.Heading
              className={_utils.cx(_styles, "homepage-h3")}
              tag="h2"
            >
              {"How it works"}
            </_Builtin.Heading>
          </_Builtin.Block>
          <_Builtin.Block
            className={_utils.cx(_styles, "homepage-feature-div")}
            tag="div"
          >
            <_Builtin.Block
              className={_utils.cx(_styles, "hiw-cards")}
              tag="div"
            >
              <_Builtin.Image
                className={_utils.cx(_styles, "hiw-graphics")}
                loading="lazy"
                width="auto"
                height="auto"
                alt=""
                src="https://cdn.prod.website-files.com/6356e5735110b93b46145859/67352c7b38315b32f60b3751_How%20it%20Works.svg"
              />
              <_Builtin.Block
                className={_utils.cx(_styles, "hiw-cards-text-div")}
                tag="div"
              >
                <_Builtin.Block
                  className={_utils.cx(_styles, "hiw-cards-header")}
                  tag="div"
                >
                  <_Builtin.Strong>{"List your Services"}</_Builtin.Strong>
                </_Builtin.Block>
                <_Builtin.Block
                  className={_utils.cx(_styles, "hiw-cards-subtext")}
                  tag="div"
                >
                  {
                    "Create your profile so clients can easily book you. Customize what you offer and how you price it."
                  }
                </_Builtin.Block>
              </_Builtin.Block>
            </_Builtin.Block>
            <_Builtin.Block
              className={_utils.cx(_styles, "hiw-cards")}
              tag="div"
            >
              <_Builtin.Image
                className={_utils.cx(_styles, "hiw-graphics")}
                loading="lazy"
                width="auto"
                height="auto"
                alt=""
                src="https://cdn.prod.website-files.com/6356e5735110b93b46145859/67352b7bcde1bd4ecb911e46_How%20it%20Works-1.svg"
              />
              <_Builtin.Block
                className={_utils.cx(_styles, "hiw-cards-text-div")}
                tag="div"
              >
                <_Builtin.Block
                  className={_utils.cx(_styles, "hiw-cards-header")}
                  tag="div"
                >
                  <_Builtin.Strong>
                    {"Manage Projects with Clients"}
                  </_Builtin.Strong>
                </_Builtin.Block>
                <_Builtin.Block
                  className={_utils.cx(_styles, "hiw-cards-subtext")}
                  tag="div"
                >
                  {
                    "Streamline your projects with centralized tools for chatting with clients, managing revision feedback, sharing files, and automated invoicing."
                  }
                </_Builtin.Block>
              </_Builtin.Block>
            </_Builtin.Block>
            <_Builtin.Block
              className={_utils.cx(_styles, "hiw-cards")}
              tag="div"
            >
              <_Builtin.Image
                className={_utils.cx(_styles, "hiw-graphics")}
                loading="lazy"
                width="auto"
                height="auto"
                alt=""
                src="https://cdn.prod.website-files.com/6356e5735110b93b46145859/67352b7b7f2aedc1595508d9_How%20it%20Works-2.svg"
              />
              <_Builtin.Block
                className={_utils.cx(_styles, "hiw-cards-text-div")}
                tag="div"
              >
                <_Builtin.Block
                  className={_utils.cx(_styles, "hiw-cards-header")}
                  tag="div"
                >
                  <_Builtin.Strong>
                    {"Receive Instant Payments"}
                  </_Builtin.Strong>
                </_Builtin.Block>
                <_Builtin.Block
                  className={_utils.cx(_styles, "hiw-cards-subtext")}
                  tag="div"
                >
                  {"Get paid as soon as projects are completed. "}
                  <br />
                  {"No more waiting."}
                </_Builtin.Block>
              </_Builtin.Block>
            </_Builtin.Block>
          </_Builtin.Block>
          <_Builtin.Link
            className={_utils.cx(
              _styles,
              "centered-button",
              "engineears-button"
            )}
            button={true}
            block=""
            options={{
              href: "http://engineears.com/add-subscription",
            }}
          >
            {"View Memberships"}
          </_Builtin.Link>
        </_Builtin.BlockContainer>
      </_Builtin.Section>
      <_Builtin.Section
        className={_utils.cx(_styles, "homepage-section")}
        grid={{
          type: "section",
        }}
        tag="section"
      >
        <_Builtin.BlockContainer
          className={_utils.cx(_styles, "homepage-container")}
          grid={{
            type: "container",
          }}
          tag="div"
        >
          <_Builtin.Block
            className={_utils.cx(_styles, "homepage-header-wrapper")}
            tag="div"
          >
            <_Builtin.Heading
              className={_utils.cx(_styles, "homepage-h2")}
              tag="h2"
            >
              {"Join our community of verifed audio engineers."}
            </_Builtin.Heading>
          </_Builtin.Block>
          <_Builtin.Block
            className={_utils.cx(_styles, "homepage-profile-cards-div")}
            tag="div"
          >
            <_Builtin.Link
              className={_utils.cx(_styles, "homepage-engineer-cards")}
              button={false}
              block="inline"
              options={{
                href: "http://engineears.com/shanemixedit",
                target: "_blank",
              }}
            >
              <_Builtin.Block
                className={_utils.cx(_styles, "div-block-101")}
                tag="div"
              >
                <_Builtin.Image
                  loading="lazy"
                  width="auto"
                  height="auto"
                  alt=""
                  src="https://cdn.prod.website-files.com/6356e5735110b93b46145859/6737f2d873b190ea1eeee47b_shane-thompson-profile-picture.jpg"
                />
              </_Builtin.Block>
              <_Builtin.Block
                className={_utils.cx(_styles, "div-block-103")}
                tag="div"
              >
                <_Builtin.Block
                  className={_utils.cx(_styles, "div-block-102")}
                  tag="div"
                >
                  <_Builtin.Block
                    className={_utils.cx(_styles, "user-card-display-name")}
                    tag="div"
                  >
                    {"Shane Thompson"}
                  </_Builtin.Block>
                  <_Builtin.Block
                    className={_utils.cx(_styles, "user-card-username")}
                    tag="div"
                  >
                    {"@shanemixedit"}
                  </_Builtin.Block>
                </_Builtin.Block>
                <_Builtin.Block
                  className={_utils.cx(_styles, "div-block-104")}
                  tag="div"
                >
                  <_Builtin.Block
                    className={_utils.cx(_styles, "price-block")}
                    tag="div"
                  >
                    {"$50+"}
                  </_Builtin.Block>
                </_Builtin.Block>
              </_Builtin.Block>
              <_Builtin.Block
                className={_utils.cx(_styles, "div-block-110")}
                tag="div"
              >
                <_Builtin.Image
                  className={_utils.cx(_styles, "image-90")}
                  loading="lazy"
                  width="auto"
                  height="auto"
                  alt=""
                  src="https://cdn.prod.website-files.com/6356e5735110b93b46145859/63e15e17e6f81a8baa2a901d_Trophies_Verified.svg"
                />
                <_Builtin.Image
                  className={_utils.cx(_styles, "image-90")}
                  loading="lazy"
                  width="auto"
                  height="auto"
                  alt="EngineEars Dolby Atmos Badge rewarded to those who have completed the EngineEars Dolby Atmos Certification Course"
                  src="https://cdn.prod.website-files.com/6356e5735110b93b46145859/673677f8c850d4136fe9606a_Dolby%20Atmos%20Badge.svg"
                />
                <_Builtin.Block
                  className={_utils.cx(_styles, "div-block-111")}
                  tag="div"
                >
                  <_Builtin.Block
                    className={_utils.cx(_styles, "text-block-41")}
                    tag="div"
                  >
                    {"Engineer"}
                  </_Builtin.Block>
                </_Builtin.Block>
              </_Builtin.Block>
              <_Builtin.Block
                className={_utils.cx(_styles, "genres-wrapper")}
                tag="div"
              >
                <_Builtin.Block
                  className={_utils.cx(_styles, "genre-pill")}
                  tag="div"
                >
                  <_Builtin.Block
                    className={_utils.cx(_styles, "text-block-42")}
                    tag="div"
                  >
                    {"Punk"}
                  </_Builtin.Block>
                </_Builtin.Block>
                <_Builtin.Block
                  className={_utils.cx(_styles, "genre-pill")}
                  tag="div"
                >
                  <_Builtin.Block
                    className={_utils.cx(_styles, "text-block-42")}
                    tag="div"
                  >
                    {"Jazz"}
                  </_Builtin.Block>
                </_Builtin.Block>
                <_Builtin.Block
                  className={_utils.cx(_styles, "genre-pill")}
                  tag="div"
                >
                  <_Builtin.Block
                    className={_utils.cx(_styles, "text-block-42")}
                    tag="div"
                  >
                    {"Rock"}
                  </_Builtin.Block>
                </_Builtin.Block>
                <_Builtin.Block
                  className={_utils.cx(_styles, "genre-pill")}
                  tag="div"
                >
                  <_Builtin.Block
                    className={_utils.cx(_styles, "text-block-42")}
                    tag="div"
                  >
                    {"House"}
                  </_Builtin.Block>
                </_Builtin.Block>
              </_Builtin.Block>
            </_Builtin.Link>
            <_Builtin.Link
              className={_utils.cx(_styles, "homepage-engineer-cards")}
              button={false}
              block="inline"
              options={{
                href: "http://engineears.com/mixedbyauden",
                target: "_blank",
              }}
            >
              <_Builtin.Block
                className={_utils.cx(_styles, "div-block-101")}
                tag="div"
              >
                <_Builtin.Image
                  loading="lazy"
                  width="auto"
                  height="auto"
                  alt=""
                  src="https://cdn.prod.website-files.com/6356e5735110b93b46145859/6737f3212aa3b51fcbbcffb6_mixed-by-auden-profile-picture.jpg"
                />
              </_Builtin.Block>
              <_Builtin.Block
                className={_utils.cx(_styles, "div-block-103")}
                tag="div"
              >
                <_Builtin.Block
                  className={_utils.cx(_styles, "div-block-102")}
                  tag="div"
                >
                  <_Builtin.Block
                    className={_utils.cx(_styles, "user-card-display-name")}
                    tag="div"
                  >
                    {"Auden"}
                  </_Builtin.Block>
                  <_Builtin.Block
                    className={_utils.cx(_styles, "user-card-username")}
                    tag="div"
                  >
                    {"@mixedbyauden"}
                  </_Builtin.Block>
                </_Builtin.Block>
                <_Builtin.Block
                  className={_utils.cx(_styles, "div-block-104")}
                  tag="div"
                >
                  <_Builtin.Block
                    className={_utils.cx(_styles, "price-block")}
                    tag="div"
                  >
                    {"$50+"}
                  </_Builtin.Block>
                </_Builtin.Block>
              </_Builtin.Block>
              <_Builtin.Block
                className={_utils.cx(_styles, "div-block-110")}
                tag="div"
              >
                <_Builtin.Image
                  className={_utils.cx(_styles, "image-90")}
                  loading="lazy"
                  width="auto"
                  height="auto"
                  alt=""
                  src="https://cdn.prod.website-files.com/6356e5735110b93b46145859/63e15e17e6f81a8baa2a901d_Trophies_Verified.svg"
                />
                <_Builtin.Image
                  className={_utils.cx(_styles, "image-90")}
                  loading="lazy"
                  width="auto"
                  height="auto"
                  alt="EngineEars Dolby Atmos Badge rewarded to those who have completed the EngineEars Dolby Atmos Certification Course"
                  src="https://cdn.prod.website-files.com/6356e5735110b93b46145859/673677f8c850d4136fe9606a_Dolby%20Atmos%20Badge.svg"
                />
                <_Builtin.Block
                  className={_utils.cx(_styles, "div-block-111")}
                  tag="div"
                >
                  <_Builtin.Block
                    className={_utils.cx(_styles, "text-block-41")}
                    tag="div"
                  >
                    {"Engineer"}
                  </_Builtin.Block>
                </_Builtin.Block>
              </_Builtin.Block>
              <_Builtin.Block
                className={_utils.cx(_styles, "genres-wrapper")}
                tag="div"
              >
                <_Builtin.Block
                  className={_utils.cx(_styles, "genre-pill")}
                  tag="div"
                >
                  <_Builtin.Block
                    className={_utils.cx(_styles, "text-block-42")}
                    tag="div"
                  >
                    {"Reggaeton"}
                  </_Builtin.Block>
                </_Builtin.Block>
                <_Builtin.Block
                  className={_utils.cx(_styles, "genre-pill")}
                  tag="div"
                >
                  <_Builtin.Block
                    className={_utils.cx(_styles, "text-block-42")}
                    tag="div"
                  >
                    {"Hip Hop"}
                  </_Builtin.Block>
                </_Builtin.Block>
                <_Builtin.Block
                  className={_utils.cx(_styles, "genre-pill")}
                  tag="div"
                >
                  <_Builtin.Block
                    className={_utils.cx(_styles, "text-block-42")}
                    tag="div"
                  >
                    {"Latin"}
                  </_Builtin.Block>
                </_Builtin.Block>
                <_Builtin.Block
                  className={_utils.cx(_styles, "genre-pill")}
                  tag="div"
                >
                  <_Builtin.Block
                    className={_utils.cx(_styles, "text-block-42")}
                    tag="div"
                  >
                    {"RnB"}
                  </_Builtin.Block>
                </_Builtin.Block>
              </_Builtin.Block>
            </_Builtin.Link>
            <_Builtin.Link
              className={_utils.cx(_styles, "homepage-engineer-cards")}
              button={false}
              block="inline"
              options={{
                href: "http://engineears.com/darshmadebeats",
                target: "_blank",
              }}
            >
              <_Builtin.Block
                className={_utils.cx(_styles, "div-block-101")}
                tag="div"
              >
                <_Builtin.Image
                  loading="lazy"
                  width="auto"
                  height="auto"
                  alt=""
                  src="https://cdn.prod.website-files.com/6356e5735110b93b46145859/6737f39714e6e06d835bbcc8_dariush-darsh-made-beats-profile-picture.jpg"
                />
              </_Builtin.Block>
              <_Builtin.Block
                className={_utils.cx(_styles, "div-block-103")}
                tag="div"
              >
                <_Builtin.Block
                  className={_utils.cx(_styles, "div-block-102")}
                  tag="div"
                >
                  <_Builtin.Block
                    className={_utils.cx(_styles, "user-card-display-name")}
                    tag="div"
                  >
                    {"Dariush"}
                  </_Builtin.Block>
                  <_Builtin.Block
                    className={_utils.cx(_styles, "user-card-username")}
                    tag="div"
                  >
                    {"@darshmadebeats"}
                  </_Builtin.Block>
                </_Builtin.Block>
                <_Builtin.Block
                  className={_utils.cx(_styles, "div-block-104")}
                  tag="div"
                >
                  <_Builtin.Block
                    className={_utils.cx(_styles, "price-block")}
                    tag="div"
                  >
                    {"$50+"}
                  </_Builtin.Block>
                </_Builtin.Block>
              </_Builtin.Block>
              <_Builtin.Block
                className={_utils.cx(_styles, "div-block-110")}
                tag="div"
              >
                <_Builtin.Image
                  className={_utils.cx(_styles, "image-90")}
                  loading="lazy"
                  width="auto"
                  height="auto"
                  alt=""
                  src="https://cdn.prod.website-files.com/6356e5735110b93b46145859/63e15e17e6f81a8baa2a901d_Trophies_Verified.svg"
                />
                <_Builtin.Image
                  className={_utils.cx(_styles, "image-90")}
                  loading="lazy"
                  width="auto"
                  height="auto"
                  alt="EngineEars Dolby Atmos Badge rewarded to those who have completed the EngineEars Dolby Atmos Certification Course"
                  src="https://cdn.prod.website-files.com/6356e5735110b93b46145859/673677f8c850d4136fe9606a_Dolby%20Atmos%20Badge.svg"
                />
                <_Builtin.Block
                  className={_utils.cx(_styles, "div-block-111")}
                  tag="div"
                >
                  <_Builtin.Block
                    className={_utils.cx(_styles, "text-block-41")}
                    tag="div"
                  >
                    {"Engineer"}
                  </_Builtin.Block>
                </_Builtin.Block>
              </_Builtin.Block>
              <_Builtin.Block
                className={_utils.cx(_styles, "genres-wrapper")}
                tag="div"
              >
                <_Builtin.Block
                  className={_utils.cx(_styles, "genre-pill")}
                  tag="div"
                >
                  <_Builtin.Block
                    className={_utils.cx(_styles, "text-block-42")}
                    tag="div"
                  >
                    {"Hip Hop"}
                  </_Builtin.Block>
                </_Builtin.Block>
                <_Builtin.Block
                  className={_utils.cx(_styles, "genre-pill")}
                  tag="div"
                >
                  <_Builtin.Block
                    className={_utils.cx(_styles, "text-block-42")}
                    tag="div"
                  >
                    {"Rock"}
                  </_Builtin.Block>
                </_Builtin.Block>
                <_Builtin.Block
                  className={_utils.cx(_styles, "genre-pill")}
                  tag="div"
                >
                  <_Builtin.Block
                    className={_utils.cx(_styles, "text-block-42")}
                    tag="div"
                  >
                    {"Jazz"}
                  </_Builtin.Block>
                </_Builtin.Block>
                <_Builtin.Block
                  className={_utils.cx(_styles, "genre-pill")}
                  tag="div"
                >
                  <_Builtin.Block
                    className={_utils.cx(_styles, "text-block-42")}
                    tag="div"
                  >
                    {"Folk"}
                  </_Builtin.Block>
                </_Builtin.Block>
              </_Builtin.Block>
            </_Builtin.Link>
            <_Builtin.Block
              className={_utils.cx(
                _styles,
                "homepage-engineer-cards",
                "endcard",
                "carousel"
              )}
              tag="div"
            >
              <_Builtin.Block
                className={_utils.cx(_styles, "s2-subheading")}
                tag="div"
              >
                {"Start offering"}
                <br />
                {"audio engineering services"}
              </_Builtin.Block>
              <_Builtin.Link
                className={_utils.cx(_styles, "engineears-button")}
                button={true}
                block=""
                options={{
                  href: "https://engineears.com/signup?flow=6&step=3",
                }}
              >
                {"Join Now"}
              </_Builtin.Link>
            </_Builtin.Block>
          </_Builtin.Block>
          <_Builtin.Block
            className={_utils.cx(
              _styles,
              "homepage-engineer-cards",
              "endcard",
              "floating"
            )}
            tag="div"
          >
            <_Builtin.Block
              className={_utils.cx(_styles, "s2-subheading")}
              tag="div"
            >
              {"Start offering"}
              <br />
              {"audio engineering services"}
            </_Builtin.Block>
            <_Builtin.Link
              className={_utils.cx(_styles, "engineears-button")}
              button={true}
              block=""
              options={{
                href: "http://engineears.com/add-subscription",
                target: "_blank",
              }}
            >
              {"Get Started"}
            </_Builtin.Link>
          </_Builtin.Block>
        </_Builtin.BlockContainer>
      </_Builtin.Section>
      <ForEngineersElevateCareer />
      <_Builtin.Section
        className={_utils.cx(_styles, "homepage-section")}
        grid={{
          type: "section",
        }}
        tag="section"
      >
        <_Builtin.BlockContainer
          className={_utils.cx(_styles, "homepage-container")}
          grid={{
            type: "container",
          }}
          tag="div"
        >
          <_Builtin.Block
            className={_utils.cx(_styles, "homepage-header-wrapper")}
            tag="div"
          >
            <_Builtin.Heading
              className={_utils.cx(_styles, "homepage-h3", "faq")}
              tag="h2"
            >
              {"See How EngineEars"}
              <br />
              {"Streamlined Their Workflow"}
            </_Builtin.Heading>
          </_Builtin.Block>
          <_Builtin.Block
            className={_utils.cx(_styles, "combine-container-medium")}
            tag="div"
          >
            <_Builtin.SliderWrapper
              className={_utils.cx(_styles, "combine-clients3_slider")}
              animation="slide"
              easing="ease"
              duration={500}
              infinite={true}
              disableSwipe={false}
              autoplay={false}
              delay={4000}
              autoMax={0}
              hideArrows={false}
              navRound={true}
              navNumbers={false}
              navShadow={false}
              navInvert={false}
              navSpacing={3}
              iconArrows={true}
            >
              <_Builtin.HtmlEmbed
                className={_utils.cx(_styles, "combine-clients3_custom-nav")}
                value="%3Cstyle%3E%0A.w-slider-dot%20%7B%0A%20%20background%3A%20currentcolor%3B%0A%20%20opacity%3A%2025%25%3B%0A%20%20width%3A%200.5rem%3B%0A%20%20height%3A%200.5rem%3B%0A%7D%0A.w-slider-dot.w-active%20%7B%0A%20%20opacity%3A%20100%25%3B%0A%20%20background%3A%20currentcolor%3B%0A%7D%0A%3C%2Fstyle%3E"
              />
              <_Builtin.SliderMask
                className={_utils.cx(_styles, "combine-clients3_mask")}
              >
                <_Builtin.SliderSlide
                  className={_utils.cx(_styles, "combine-clients3_slide")}
                  tag="div"
                >
                  <_Builtin.Block
                    className={_utils.cx(_styles, "div-block-106")}
                    tag="div"
                  >
                    <_Builtin.Block
                      className={_utils.cx(_styles, "div-block-107")}
                      tag="div"
                    >
                      <_Builtin.Image
                        className={_utils.cx(_styles, "combine-clients3_image")}
                        width="auto"
                        height="auto"
                        loading="lazy"
                        alt=""
                        src="https://cdn.prod.website-files.com/6356e5735110b93b46145859/673f73eb57c275774ec03f79_JNY-Profile-Picture.jpg"
                      />
                    </_Builtin.Block>
                    <_Builtin.Block
                      className={_utils.cx(_styles, "combine-clients3_item")}
                      tag="div"
                    >
                      <_Builtin.Block
                        className={_utils.cx(_styles, "qt-name-div")}
                        id={_utils.cx(
                          _styles,
                          "w-node-_2c048298-597e-90dd-8b61-17a7741954c8-741953c4"
                        )}
                        tag="div"
                      >
                        <_Builtin.Block
                          className={_utils.cx(_styles, "qt-client-name")}
                          id={_utils.cx(
                            _styles,
                            "w-node-_2c048298-597e-90dd-8b61-17a7741954c9-741953c4"
                          )}
                          tag="div"
                        >
                          {"Jennifer Ortiz"}
                        </_Builtin.Block>
                        <_Builtin.Block
                          className={_utils.cx(_styles, "div-block-109")}
                          id={_utils.cx(
                            _styles,
                            "w-node-_2c048298-597e-90dd-8b61-17a7741954cb-741953c4"
                          )}
                          tag="div"
                        >
                          <_Builtin.Block
                            className={_utils.cx(_styles, "qt-subtext-1")}
                            id={_utils.cx(
                              _styles,
                              "w-node-_2c048298-597e-90dd-8b61-17a7741954cc-741953c4"
                            )}
                            tag="div"
                          >
                            {"@jny.mixedit"}
                          </_Builtin.Block>
                          <_Builtin.Block
                            className={_utils.cx(_styles, "qt-subtext-2")}
                            id={_utils.cx(
                              _styles,
                              "w-node-_2c048298-597e-90dd-8b61-17a7741954ce-741953c4"
                            )}
                            tag="div"
                          >
                            {"Los Angeles, California"}
                          </_Builtin.Block>
                        </_Builtin.Block>
                      </_Builtin.Block>
                      <_Builtin.Block
                        className={_utils.cx(_styles, "qt-header-text")}
                        tag="div"
                      >
                        {
                          "If you’re looking to grow and evolve as an engineer, EngineEars is the place to be. It’s not just a platform; it’s a community of like-minded professionals who support each other"
                        }
                      </_Builtin.Block>
                    </_Builtin.Block>
                  </_Builtin.Block>
                </_Builtin.SliderSlide>
                <_Builtin.SliderSlide
                  className={_utils.cx(_styles, "combine-clients3_slide")}
                  tag="div"
                >
                  <_Builtin.Block
                    className={_utils.cx(_styles, "div-block-106")}
                    tag="div"
                  >
                    <_Builtin.Block
                      className={_utils.cx(_styles, "div-block-107")}
                      tag="div"
                    >
                      <_Builtin.Image
                        className={_utils.cx(_styles, "combine-clients3_image")}
                        width="auto"
                        height="auto"
                        loading="lazy"
                        alt=""
                        src="https://cdn.prod.website-files.com/6356e5735110b93b46145859/6737d92430c38b3c42eb1f48_vintage_division_1663666349_2931368257188014907_1414138898.jpg"
                      />
                    </_Builtin.Block>
                    <_Builtin.Block
                      className={_utils.cx(_styles, "combine-clients3_item")}
                      tag="div"
                    >
                      <_Builtin.Block
                        className={_utils.cx(_styles, "qt-name-div")}
                        id={_utils.cx(
                          _styles,
                          "w-node-_2c048298-597e-90dd-8b61-17a7741954d7-741953c4"
                        )}
                        tag="div"
                      >
                        <_Builtin.Block
                          className={_utils.cx(_styles, "qt-client-name")}
                          id={_utils.cx(
                            _styles,
                            "w-node-_2c048298-597e-90dd-8b61-17a7741954d8-741953c4"
                          )}
                          tag="div"
                        >
                          {"Paul Jalowiecki"}
                        </_Builtin.Block>
                        <_Builtin.Block
                          className={_utils.cx(_styles, "div-block-109")}
                          id={_utils.cx(
                            _styles,
                            "w-node-_2c048298-597e-90dd-8b61-17a7741954da-741953c4"
                          )}
                          tag="div"
                        >
                          <_Builtin.Block
                            className={_utils.cx(_styles, "qt-subtext-1")}
                            id={_utils.cx(
                              _styles,
                              "w-node-_2c048298-597e-90dd-8b61-17a7741954db-741953c4"
                            )}
                            tag="div"
                          >
                            {"Chrome Mastering"}
                          </_Builtin.Block>
                          <_Builtin.Block
                            className={_utils.cx(_styles, "qt-subtext-2")}
                            id={_utils.cx(
                              _styles,
                              "w-node-_2c048298-597e-90dd-8b61-17a7741954dd-741953c4"
                            )}
                            tag="div"
                          >
                            {"Manchester, United Kingdom"}
                          </_Builtin.Block>
                        </_Builtin.Block>
                      </_Builtin.Block>
                      <_Builtin.Block
                        className={_utils.cx(_styles, "qt-header-text")}
                        tag="div"
                      >
                        {
                          "The most innovative platform for audio engineers, hands down. I love [the] modern design and very detailed statistics about your profile."
                        }
                      </_Builtin.Block>
                    </_Builtin.Block>
                  </_Builtin.Block>
                </_Builtin.SliderSlide>
                <_Builtin.SliderSlide
                  className={_utils.cx(_styles, "combine-clients3_slide")}
                  tag="div"
                >
                  <_Builtin.Block
                    className={_utils.cx(_styles, "div-block-106")}
                    tag="div"
                  >
                    <_Builtin.Block
                      className={_utils.cx(_styles, "div-block-107")}
                      tag="div"
                    >
                      <_Builtin.Image
                        className={_utils.cx(_styles, "combine-clients3_image")}
                        width="auto"
                        height="auto"
                        loading="lazy"
                        alt=""
                        src="https://cdn.prod.website-files.com/6356e5735110b93b46145859/673f8e51b0c8d8d15aff2666_Thomas-Warren-WF-Profile-Pctures.jpg"
                      />
                    </_Builtin.Block>
                    <_Builtin.Block
                      className={_utils.cx(_styles, "combine-clients3_item")}
                      tag="div"
                    >
                      <_Builtin.Block
                        className={_utils.cx(_styles, "qt-name-div")}
                        id={_utils.cx(
                          _styles,
                          "w-node-_2c048298-597e-90dd-8b61-17a7741954e6-741953c4"
                        )}
                        tag="div"
                      >
                        <_Builtin.Block
                          className={_utils.cx(_styles, "qt-client-name")}
                          id={_utils.cx(
                            _styles,
                            "w-node-_2c048298-597e-90dd-8b61-17a7741954e7-741953c4"
                          )}
                          tag="div"
                        >
                          {"Thomas Warren"}
                        </_Builtin.Block>
                        <_Builtin.Block
                          className={_utils.cx(_styles, "div-block-109")}
                          id={_utils.cx(
                            _styles,
                            "w-node-_2c048298-597e-90dd-8b61-17a7741954e9-741953c4"
                          )}
                          tag="div"
                        >
                          <_Builtin.Block
                            className={_utils.cx(_styles, "qt-subtext-1")}
                            id={_utils.cx(
                              _styles,
                              "w-node-_2c048298-597e-90dd-8b61-17a7741954ea-741953c4"
                            )}
                            tag="div"
                          >
                            {"@mixedbythomas"}
                          </_Builtin.Block>
                          <_Builtin.Block
                            className={_utils.cx(_styles, "qt-subtext-2")}
                            id={_utils.cx(
                              _styles,
                              "w-node-_2c048298-597e-90dd-8b61-17a7741954ec-741953c4"
                            )}
                            tag="div"
                          >
                            {"Los Angeles, California"}
                          </_Builtin.Block>
                        </_Builtin.Block>
                      </_Builtin.Block>
                      <_Builtin.Block
                        className={_utils.cx(_styles, "qt-header-text")}
                        tag="div"
                      >
                        {
                          "Clients love the A/B feature and being able to leave time stamped notes for a clear and seamless revision. Highly recommend for any serious mixing engineer."
                        }
                      </_Builtin.Block>
                    </_Builtin.Block>
                  </_Builtin.Block>
                </_Builtin.SliderSlide>
                <_Builtin.SliderSlide
                  className={_utils.cx(_styles, "combine-clients3_slide")}
                  tag="div"
                >
                  <_Builtin.Block
                    className={_utils.cx(_styles, "div-block-106")}
                    tag="div"
                  >
                    <_Builtin.Block
                      className={_utils.cx(_styles, "div-block-107")}
                      tag="div"
                    >
                      <_Builtin.Image
                        className={_utils.cx(_styles, "combine-clients3_image")}
                        width="auto"
                        height="auto"
                        loading="lazy"
                        alt=""
                        src="https://cdn.prod.website-files.com/6356e5735110b93b46145859/673f8d11826d17aa5052675d__28keepyastr8_1591167081_2323200322549305721_9007076140.jpg"
                      />
                    </_Builtin.Block>
                    <_Builtin.Block
                      className={_utils.cx(_styles, "combine-clients3_item")}
                      tag="div"
                    >
                      <_Builtin.Block
                        className={_utils.cx(_styles, "qt-name-div")}
                        id={_utils.cx(
                          _styles,
                          "w-node-_2c048298-597e-90dd-8b61-17a7741954f5-741953c4"
                        )}
                        tag="div"
                      >
                        <_Builtin.Block
                          className={_utils.cx(_styles, "qt-client-name")}
                          id={_utils.cx(
                            _styles,
                            "w-node-_2c048298-597e-90dd-8b61-17a7741954f6-741953c4"
                          )}
                          tag="div"
                        >
                          {'Marlon "28" Evins'}
                        </_Builtin.Block>
                        <_Builtin.Block
                          className={_utils.cx(_styles, "div-block-109")}
                          id={_utils.cx(
                            _styles,
                            "w-node-_2c048298-597e-90dd-8b61-17a7741954f8-741953c4"
                          )}
                          tag="div"
                        >
                          <_Builtin.Block
                            className={_utils.cx(_styles, "qt-subtext-1")}
                            id={_utils.cx(
                              _styles,
                              "w-node-_2c048298-597e-90dd-8b61-17a7741954f9-741953c4"
                            )}
                            tag="div"
                          >
                            {"@28keepyastr8"}
                          </_Builtin.Block>
                          <_Builtin.Block
                            className={_utils.cx(_styles, "qt-subtext-2")}
                            id={_utils.cx(
                              _styles,
                              "w-node-_2c048298-597e-90dd-8b61-17a7741954fb-741953c4"
                            )}
                            tag="div"
                          >
                            {"Raleigh, North Carolina"}
                          </_Builtin.Block>
                        </_Builtin.Block>
                      </_Builtin.Block>
                      <_Builtin.Block
                        className={_utils.cx(_styles, "qt-header-text")}
                        tag="div"
                      >
                        {
                          "The platform’s tools and resources are top-notch, providing everything an audio engineer needs to create professional-level results."
                        }
                      </_Builtin.Block>
                    </_Builtin.Block>
                  </_Builtin.Block>
                </_Builtin.SliderSlide>
              </_Builtin.SliderMask>
              <_Builtin.SliderArrow
                className={_utils.cx(_styles, "combine-clients3_left-arrow")}
                dir="left"
              >
                <_Builtin.Block
                  className={_utils.cx(_styles, "combine-clients3_circle")}
                  tag="div"
                >
                  <_Builtin.HtmlEmbed
                    className={_utils.cx(_styles, "combine-icon_small")}
                    value="%3Csvg%20width%3D%22currentWidth%22%20height%3D%22currentHeight%22%20viewBox%3D%220%200%2016%2016%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%0A%3Cpath%20d%3D%22M9.5%2013L4.5%208L9.5%203%22%20stroke%3D%22currentColor%22%20stroke-width%3D%222%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%0A%3C%2Fsvg%3E"
                  />
                </_Builtin.Block>
              </_Builtin.SliderArrow>
              <_Builtin.SliderArrow
                className={_utils.cx(_styles, "combine-clients3_right-arrow")}
                dir="right"
              >
                <_Builtin.Block
                  className={_utils.cx(_styles, "combine-clients3_circle")}
                  tag="div"
                >
                  <_Builtin.HtmlEmbed
                    className={_utils.cx(_styles, "combine-icon_small")}
                    value="%3Csvg%20width%3D%22100%25%22%20height%3D%22currentHeight%22%20viewBox%3D%220%200%2016%2016%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%0A%3Cpath%20d%3D%22M6.83301%2013L11.833%208L6.83301%203%22%20stroke%3D%22currentColor%22%20stroke-width%3D%222%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%0A%3C%2Fsvg%3E"
                  />
                </_Builtin.Block>
              </_Builtin.SliderArrow>
              <_Builtin.SliderNav
                className={_utils.cx(_styles, "combine-clients3_slide-nav")}
              />
            </_Builtin.SliderWrapper>
          </_Builtin.Block>
          <_Builtin.Link
            className={_utils.cx(
              _styles,
              "engineears-button",
              "centered-button"
            )}
            button={true}
            block=""
            options={{
              href: "http://community.engineears.com/case-studies",
            }}
          >
            {"Read More"}
          </_Builtin.Link>
        </_Builtin.BlockContainer>
      </_Builtin.Section>
      <_Builtin.Block
        className={_utils.cx(_styles, "combine-section_feature7")}
        tag="section"
      >
        <_Builtin.Block
          className={_utils.cx(_styles, "combine-padding-global-5")}
          tag="div"
        >
          <_Builtin.Block
            className={_utils.cx(_styles, "combine-container-large-4")}
            tag="div"
          >
            <_Builtin.Block
              className={_utils.cx(_styles, "combine-padding-section-medium-5")}
              tag="div"
            >
              <_Builtin.Block
                className={_utils.cx(_styles, "combine-feature7_component")}
                tag="div"
              >
                <_Builtin.Block
                  className={_utils.cx(
                    _styles,
                    "combine-feature7_content-sticky"
                  )}
                  tag="div"
                >
                  <_Builtin.Heading
                    className={_utils.cx(_styles, "combine-heading-style-h2-5")}
                    tag="h2"
                  >
                    {"Start Building New Stunning Websites"}
                  </_Builtin.Heading>
                  <_Builtin.Block
                    className={_utils.cx(
                      _styles,
                      "combine-text-size-regular-6"
                    )}
                    tag="div"
                  >
                    {
                      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse varius enim in eros elementum tristique. Duis cursus, mi quis viverra ornare, eros dolor interdum nulla, ut commodo diam libero vitae erat."
                    }
                  </_Builtin.Block>
                  <_Builtin.Link
                    className={_utils.cx(_styles, "combine-button-icon-2")}
                    button={false}
                    block="inline"
                    options={{
                      href: "#",
                    }}
                  >
                    <_Builtin.Block
                      className={_utils.cx(_styles, "combine-button-content-2")}
                      tag="div"
                    >
                      <_Builtin.Block tag="div">{"Learn More"}</_Builtin.Block>
                      <_Builtin.HtmlEmbed
                        className={_utils.cx(
                          _styles,
                          "combine-chevron-right_icon-2"
                        )}
                        value="%3Csvg%20width%3D%22100%25%22%20height%3D%22currentHeight%22%20viewBox%3D%220%200%2016%2016%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%0A%3Cpath%20d%3D%22M6.83301%2013L11.833%208L6.83301%203%22%20stroke%3D%22currentColor%22%20stroke-width%3D%222%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%0A%3C%2Fsvg%3E"
                      />
                    </_Builtin.Block>
                  </_Builtin.Link>
                </_Builtin.Block>
                <_Builtin.Block
                  className={_utils.cx(_styles, "combine-feature7_wrapper")}
                  tag="div"
                >
                  <_Builtin.Block
                    className={_utils.cx(_styles, "combine-feature7_item")}
                    tag="div"
                  >
                    <_Builtin.Block
                      className={_utils.cx(_styles, "combine-icon_color1")}
                      tag="div"
                    >
                      <_Builtin.HtmlEmbed
                        className={_utils.cx(_styles, "combine-icon_large")}
                        value="%3Csvg%20width%3D%22currentWidth%22%20height%3D%22currentHeight%22%20viewBox%3D%220%200%2036%2036%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%0A%3Cg%20clip-path%3D%22url(%23clip0_628_1108)%22%3E%0A%3Cpath%20d%3D%22M18%2017.3012L11.0642%2013.8333L18%2010.3654L24.9358%2013.8333L18%2017.3012Z%22%20fill%3D%22currentColor%22%2F%3E%0A%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M12%200C5.37258%200%200%205.37258%200%2012V24C0%2030.6274%205.37258%2036%2012%2036H24C30.6274%2036%2036%2030.6274%2036%2024V12C36%205.37258%2030.6274%200%2024%200H12ZM18.2795%209.10765C18.1036%209.01967%2017.8964%209.01967%2017.7205%209.10765L9.38716%2013.2743C9.17542%2013.3802%209.04167%2013.5966%209.04167%2013.8333C9.04167%2014.0701%209.17542%2014.2865%209.38716%2014.3924L17.7205%2018.559C17.8964%2018.647%2018.1036%2018.647%2018.2795%2018.559L26.6128%2014.3924C26.8246%2014.2865%2026.9583%2014.0701%2026.9583%2013.8333C26.9583%2013.5966%2026.8246%2013.3802%2026.6128%2013.2743L18.2795%209.10765ZM9.10765%2021.8872C9.26202%2021.5784%209.63744%2021.4533%209.94618%2021.6077L18%2025.6346L26.0538%2021.6077C26.3626%2021.4533%2026.738%2021.5784%2026.8923%2021.8872C27.0467%2022.1959%2026.9216%2022.5713%2026.6128%2022.7257L18.2795%2026.8924C18.1036%2026.9803%2017.8964%2026.9803%2017.7205%2026.8924L9.38716%2022.7257C9.07842%2022.5713%208.95328%2022.1959%209.10765%2021.8872ZM9.94618%2017.441C9.63744%2017.2866%209.26202%2017.4118%209.10765%2017.7205C8.95328%2018.0292%209.07842%2018.4046%209.38716%2018.559L17.7205%2022.7257C17.8964%2022.8137%2018.1036%2022.8137%2018.2795%2022.7257L26.6128%2018.559C26.9216%2018.4046%2027.0467%2018.0292%2026.8923%2017.7205C26.738%2017.4118%2026.3626%2017.2866%2026.0538%2017.441L18%2021.4679L9.94618%2017.441Z%22%20fill%3D%22currentColor%22%2F%3E%0A%3C%2Fg%3E%0A%3Cdefs%3E%0A%3CclipPath%20id%3D%22clip0_628_1108%22%3E%0A%3Crect%20width%3D%2236%22%20height%3D%2236%22%20fill%3D%22currentColor%22%2F%3E%0A%3C%2FclipPath%3E%0A%3C%2Fdefs%3E%0A%3C%2Fsvg%3E"
                      />
                    </_Builtin.Block>
                    <_Builtin.Heading
                      className={_utils.cx(
                        _styles,
                        "combine-heading-style-h5-2"
                      )}
                      tag="h3"
                    >
                      {"Customize Your Services"}
                    </_Builtin.Heading>
                    <_Builtin.Block
                      className={_utils.cx(
                        _styles,
                        "combine-text-size-regular-6"
                      )}
                      tag="div"
                    >
                      {
                        "Seamlessly manage your rates and packages across indie and label clientele. Enable promo codes, configure discounts, and specify custom pricing with shareable booking links."
                      }
                    </_Builtin.Block>
                  </_Builtin.Block>
                  <_Builtin.Block
                    className={_utils.cx(_styles, "combine-feature7_item")}
                    tag="div"
                  >
                    <_Builtin.Block
                      className={_utils.cx(_styles, "combine-icon_color3-2")}
                      tag="div"
                    >
                      <_Builtin.HtmlEmbed
                        className={_utils.cx(_styles, "combine-icon_large")}
                        value="%3Csvg%20width%3D%22currentWidth%22%20height%3D%22currentHeight%22%20viewBox%3D%220%200%2036%2036%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%0A%3Cg%20clip-path%3D%22url(%23clip0_628_1130)%22%3E%0A%3Cpath%20d%3D%22M12.7917%2013.8333C12.7917%2012.3376%2014.0042%2011.125%2015.5%2011.125C16.9958%2011.125%2018.2083%2012.3376%2018.2083%2013.8333C18.2083%2015.3291%2016.9958%2016.5417%2015.5%2016.5417C14.0042%2016.5417%2012.7917%2015.3291%2012.7917%2013.8333Z%22%20fill%3D%22currentColor%22%2F%3E%0A%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M0%2012C0%205.37258%205.37258%200%2012%200H24C30.6274%200%2036%205.37258%2036%2012V24C36%2030.6274%2030.6274%2036%2024%2036H12C5.37258%2036%200%2030.6274%200%2024V12ZM9.3677%2021.0344C10.11%2020.292%2011.1169%2019.875%2012.1667%2019.875H18.8333C19.8831%2019.875%2020.89%2020.292%2021.6323%2021.0344C22.3746%2021.7767%2022.7917%2022.7835%2022.7917%2023.8333V25.5C22.7917%2025.8452%2022.5118%2026.125%2022.1667%2026.125C21.8215%2026.125%2021.5417%2025.8452%2021.5417%2025.5V23.8333C21.5417%2023.115%2021.2563%2022.4262%2020.7484%2021.9183C20.2405%2021.4103%2019.5516%2021.125%2018.8333%2021.125H12.1667C11.4484%2021.125%2010.7595%2021.4103%2010.2516%2021.9183C9.74367%2022.4262%209.45833%2023.115%209.45833%2023.8333V25.5C9.45833%2025.8452%209.17851%2026.125%208.83333%2026.125C8.48816%2026.125%208.20833%2025.8452%208.20833%2025.5V23.8333C8.20833%2022.7835%208.62537%2021.7767%209.3677%2021.0344ZM15.5%209.875C13.3139%209.875%2011.5417%2011.6472%2011.5417%2013.8333C11.5417%2016.0195%2013.3139%2017.7917%2015.5%2017.7917C17.6861%2017.7917%2019.4583%2016.0195%2019.4583%2013.8333C19.4583%2011.6472%2017.6861%209.875%2015.5%209.875ZM24.0615%2020.4521C24.1478%2020.1179%2024.4887%2019.9169%2024.8229%2020.0032C25.6721%2020.2224%2026.4244%2020.7175%2026.9618%2021.4107C27.4991%2022.1038%2027.791%2022.9558%2027.7917%2023.8329V25.5C27.7917%2025.8452%2027.5118%2026.125%2027.1667%2026.125C26.8215%2026.125%2026.5417%2025.8452%2026.5417%2025.5V23.8338C26.5412%2023.2338%2026.3415%2022.6507%2025.9738%2022.1765C25.6062%2021.7022%2025.0914%2021.3635%2024.5104%2021.2135C24.1762%2021.1272%2023.9752%2020.7863%2024.0615%2020.4521ZM21.4884%2010.0029C21.154%209.91725%2020.8135%2010.1189%2020.7279%2010.4533C20.6422%2010.7877%2020.8439%2011.1282%2021.1783%2011.2138C21.7609%2011.363%2022.2772%2011.7018%2022.646%2012.1768C23.0147%2012.6519%2023.2149%2013.2361%2023.2149%2013.8375C23.2149%2014.4389%2023.0147%2015.0231%2022.646%2015.4982C22.2772%2015.9732%2021.7609%2016.312%2021.1783%2016.4612C20.8439%2016.5468%2020.6422%2016.8873%2020.7279%2017.2217C20.8135%2017.5561%2021.154%2017.7578%2021.4884%2017.6721C22.3398%2017.4541%2023.0945%2016.9589%2023.6334%2016.2646C24.1723%2015.5703%2024.4649%2014.7164%2024.4649%2013.8375C24.4649%2012.9586%2024.1723%2012.1047%2023.6334%2011.4104C23.0945%2010.7161%2022.3398%2010.2209%2021.4884%2010.0029Z%22%20fill%3D%22currentColor%22%2F%3E%0A%3C%2Fg%3E%0A%3Cdefs%3E%0A%3CclipPath%20id%3D%22clip0_628_1130%22%3E%0A%3Crect%20width%3D%2236%22%20height%3D%2236%22%20fill%3D%22currentColor%22%2F%3E%0A%3C%2FclipPath%3E%0A%3C%2Fdefs%3E%0A%3C%2Fsvg%3E"
                      />
                    </_Builtin.Block>
                    <_Builtin.Heading
                      className={_utils.cx(
                        _styles,
                        "combine-heading-style-h5-2"
                      )}
                      tag="h3"
                    >
                      {"Grow Your Brand"}
                    </_Builtin.Heading>
                    <_Builtin.Block
                      className={_utils.cx(
                        _styles,
                        "combine-text-size-regular-6"
                      )}
                      tag="div"
                    >
                      {
                        "Attract clientele by creating your shareable profile to advertise your services. Highlight your past work, showcase your achievements, connect your socials and much more."
                      }
                    </_Builtin.Block>
                  </_Builtin.Block>
                  <_Builtin.Block
                    className={_utils.cx(_styles, "combine-feature7_item")}
                    tag="div"
                  >
                    <_Builtin.Block
                      className={_utils.cx(_styles, "combine-icon_color2")}
                      tag="div"
                    >
                      <_Builtin.HtmlEmbed
                        className={_utils.cx(_styles, "combine-icon_large")}
                        value="%3Csvg%20width%3D%22currentWidth%22%20height%3D%22currentHeight%22%20viewBox%3D%220%200%2036%2036%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%0A%3Cg%20clip-path%3D%22url(%23clip0_628_1136)%22%3E%0A%3Cpath%20d%3D%22M16.125%2019.875V16.125H19.875V19.875H16.125Z%22%20fill%3D%22currentColor%22%2F%3E%0A%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M13%2011.9583C12.4247%2011.9583%2011.9583%2012.4247%2011.9583%2013V23C11.9583%2023.5753%2012.4247%2024.0417%2013%2024.0417H23C23.5753%2024.0417%2024.0417%2023.5753%2024.0417%2023V13C24.0417%2012.4247%2023.5753%2011.9583%2023%2011.9583H13ZM15.5%2014.875C15.1548%2014.875%2014.875%2015.1548%2014.875%2015.5V20.5C14.875%2020.8452%2015.1548%2021.125%2015.5%2021.125H20.5C20.8452%2021.125%2021.125%2020.8452%2021.125%2020.5V15.5C21.125%2015.1548%2020.8452%2014.875%2020.5%2014.875H15.5Z%22%20fill%3D%22currentColor%22%2F%3E%0A%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M0%2012C0%205.37258%205.37258%200%2012%200H24C30.6274%200%2036%205.37258%2036%2012V24C36%2030.6274%2030.6274%2036%2024%2036H12C5.37258%2036%200%2030.6274%200%2024V12ZM10.7083%2020.2917V23C10.7083%2024.2657%2011.7343%2025.2917%2013%2025.2917H14.875V27.1667C14.875%2027.5118%2015.1548%2027.7917%2015.5%2027.7917C15.8452%2027.7917%2016.125%2027.5118%2016.125%2027.1667V25.2917H19.875V27.1667C19.875%2027.5118%2020.1548%2027.7917%2020.5%2027.7917C20.8452%2027.7917%2021.125%2027.5118%2021.125%2027.1667V25.2917H23C24.2657%2025.2917%2025.2917%2024.2657%2025.2917%2023V20.2917H27.1667C27.5118%2020.2917%2027.7917%2020.0118%2027.7917%2019.6667C27.7917%2019.3215%2027.5118%2019.0417%2027.1667%2019.0417H25.2917V16.125H27.1667C27.5118%2016.125%2027.7917%2015.8452%2027.7917%2015.5C27.7917%2015.1548%2027.5118%2014.875%2027.1667%2014.875H25.2917V13C25.2917%2011.7343%2024.2657%2010.7083%2023%2010.7083H21.125V8.83333C21.125%208.48816%2020.8452%208.20833%2020.5%208.20833C20.1548%208.20833%2019.875%208.48816%2019.875%208.83333V10.7083H16.125V8.83333C16.125%208.48816%2015.8452%208.20833%2015.5%208.20833C15.1548%208.20833%2014.875%208.48816%2014.875%208.83333V10.7083H13C11.7343%2010.7083%2010.7083%2011.7343%2010.7083%2013V14.875H8.83333C8.48816%2014.875%208.20833%2015.1548%208.20833%2015.5C8.20833%2015.8452%208.48816%2016.125%208.83333%2016.125H10.7083V19.0417H8.83333C8.48816%2019.0417%208.20833%2019.3215%208.20833%2019.6667C8.20833%2020.0118%208.48816%2020.2917%208.83333%2020.2917H10.7083Z%22%20fill%3D%22currentColor%22%2F%3E%0A%3C%2Fg%3E%0A%3Cdefs%3E%0A%3CclipPath%20id%3D%22clip0_628_1136%22%3E%0A%3Crect%20width%3D%2236%22%20height%3D%2236%22%20fill%3D%22currentColor%22%2F%3E%0A%3C%2FclipPath%3E%0A%3C%2Fdefs%3E%0A%3C%2Fsvg%3E"
                      />
                    </_Builtin.Block>
                    <_Builtin.Heading
                      className={_utils.cx(
                        _styles,
                        "combine-heading-style-h5-2"
                      )}
                      tag="h3"
                    >
                      {"Streamline Efficiencies"}
                    </_Builtin.Heading>
                    <_Builtin.Block
                      className={_utils.cx(
                        _styles,
                        "combine-text-size-regular-6"
                      )}
                      tag="div"
                    >
                      {
                        "Consolidate the way you manage scheduling, client communications, file storage, project tracking and deliverables in one centralized tool, so you can focus on producing top-quality mixes."
                      }
                    </_Builtin.Block>
                  </_Builtin.Block>
                  <_Builtin.Block
                    className={_utils.cx(_styles, "combine-feature7_item")}
                    tag="div"
                  >
                    <_Builtin.Block
                      className={_utils.cx(_styles, "combine-icon_color4-2")}
                      tag="div"
                    >
                      <_Builtin.HtmlEmbed
                        className={_utils.cx(_styles, "combine-icon_large")}
                        value="%3Csvg%20width%3D%22currentWidth%22%20height%3D%22currentHeight%22%20viewBox%3D%220%200%2036%2036%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%0A%3Cg%20clip-path%3D%22url(%23clip0_628_1119)%22%3E%0A%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M12%200C5.37258%200%200%205.37258%200%2012V24C0%2030.6274%205.37258%2036%2012%2036H24C30.6274%2036%2036%2030.6274%2036%2024V12C36%205.37258%2030.6274%200%2024%200H12ZM13.8333%2019.0417C14.1785%2019.0417%2014.4583%2019.3215%2014.4583%2019.6667C14.4583%2020.0118%2014.1785%2020.2917%2013.8333%2020.2917H11.9583V25.5C11.9583%2025.8452%2011.6785%2026.125%2011.3333%2026.125C10.9882%2026.125%2010.7083%2025.8452%2010.7083%2025.5V20.2917H8.83333C8.48816%2020.2917%208.20833%2020.0118%208.20833%2019.6667C8.20833%2019.3215%208.48816%2019.0417%208.83333%2019.0417H13.8333ZM11.3333%209.875C11.6785%209.875%2011.9583%2010.1548%2011.9583%2010.5V16.3333C11.9583%2016.6785%2011.6785%2016.9583%2011.3333%2016.9583C10.9882%2016.9583%2010.7083%2016.6785%2010.7083%2016.3333V10.5C10.7083%2010.1548%2010.9882%209.875%2011.3333%209.875ZM18.625%2018C18.625%2017.6548%2018.3452%2017.375%2018%2017.375C17.6548%2017.375%2017.375%2017.6548%2017.375%2018V25.5C17.375%2025.8452%2017.6548%2026.125%2018%2026.125C18.3452%2026.125%2018.625%2025.8452%2018.625%2025.5V18ZM18%209.875C18.3452%209.875%2018.625%2010.1548%2018.625%2010.5V14.0417H20.5C20.8452%2014.0417%2021.125%2014.3215%2021.125%2014.6667C21.125%2015.0118%2020.8452%2015.2917%2020.5%2015.2917H15.5C15.1548%2015.2917%2014.875%2015.0118%2014.875%2014.6667C14.875%2014.3215%2015.1548%2014.0417%2015.5%2014.0417H17.375V10.5C17.375%2010.1548%2017.6548%209.875%2018%209.875ZM24.0417%2021.9583H22.1667C21.8215%2021.9583%2021.5417%2021.6785%2021.5417%2021.3333C21.5417%2020.9882%2021.8215%2020.7083%2022.1667%2020.7083H27.1667C27.5118%2020.7083%2027.7917%2020.9882%2027.7917%2021.3333C27.7917%2021.6785%2027.5118%2021.9583%2027.1667%2021.9583H25.2917V25.5C25.2917%2025.8452%2025.0118%2026.125%2024.6667%2026.125C24.3215%2026.125%2024.0417%2025.8452%2024.0417%2025.5V21.9583ZM24.6667%209.875C25.0118%209.875%2025.2917%2010.1548%2025.2917%2010.5V18C25.2917%2018.3452%2025.0118%2018.625%2024.6667%2018.625C24.3215%2018.625%2024.0417%2018.3452%2024.0417%2018V10.5C24.0417%2010.1548%2024.3215%209.875%2024.6667%209.875Z%22%20fill%3D%22currentColor%22%2F%3E%0A%3C%2Fg%3E%0A%3Cdefs%3E%0A%3CclipPath%20id%3D%22clip0_628_1119%22%3E%0A%3Crect%20width%3D%2236%22%20height%3D%2236%22%20fill%3D%22currentColor%22%2F%3E%0A%3C%2FclipPath%3E%0A%3C%2Fdefs%3E%0A%3C%2Fsvg%3E"
                      />
                    </_Builtin.Block>
                    <_Builtin.Heading
                      className={_utils.cx(
                        _styles,
                        "combine-heading-style-h5-2"
                      )}
                      tag="h3"
                    >
                      {"Simplify Finances"}
                    </_Builtin.Heading>
                    <_Builtin.Block
                      className={_utils.cx(
                        _styles,
                        "combine-text-size-regular-6"
                      )}
                      tag="div"
                    >
                      {
                        "Streamline your bookkeeping with automated invoices/receipts, logged transaction history, payment status tracking, and consolidated tax statements for export."
                      }
                    </_Builtin.Block>
                  </_Builtin.Block>
                </_Builtin.Block>
              </_Builtin.Block>
            </_Builtin.Block>
          </_Builtin.Block>
        </_Builtin.Block>
      </_Builtin.Block>
      <_Builtin.Block
        className={_utils.cx(_styles, "combine-section_clients3")}
        tag="section"
      >
        <_Builtin.Block
          className={_utils.cx(_styles, "combine-padding-global-3")}
          tag="div"
        />
      </_Builtin.Block>
      <_Builtin.Section
        className={_utils.cx(_styles, "homepage-section")}
        grid={{
          type: "section",
        }}
        tag="section"
      >
        <_Builtin.BlockContainer
          className={_utils.cx(_styles, "homepage-container")}
          grid={{
            type: "container",
          }}
          tag="div"
        >
          <_Builtin.Block
            className={_utils.cx(_styles, "combine-padding-section-medium-3")}
            tag="div"
          >
            <_Builtin.Heading
              className={_utils.cx(_styles, "homepage-h3")}
              tag="h3"
            >
              {"Frequently Asked Questions"}
            </_Builtin.Heading>
            <_Builtin.Block
              className={_utils.cx(_styles, "combine-container-small-2")}
              tag="div"
            >
              <_Builtin.Block
                className={_utils.cx(_styles, "combine-text-align-center-2")}
                tag="div"
              >
                <_Builtin.Block
                  className={_utils.cx(_styles, "combine-space-medium-2")}
                  tag="div"
                />
              </_Builtin.Block>
            </_Builtin.Block>
            <_Builtin.Block
              className={_utils.cx(_styles, "combine-space-large-2")}
              tag="div"
            />
            <_Builtin.Block
              className={_utils.cx(_styles, "combine-container-medium")}
              tag="div"
            >
              <_Builtin.Block
                className={_utils.cx(_styles, "combine-faq1_component")}
                tag="div"
              >
                <_Builtin.Block
                  className={_utils.cx(_styles, "combine-faq1_accordion")}
                  id={_utils.cx(
                    _styles,
                    "w-node-_2c048298-597e-90dd-8b61-17a774195515-741953c4"
                  )}
                  tag="div"
                >
                  <_Builtin.Block
                    className={_utils.cx(_styles, "combine-faq1_question")}
                    tag="div"
                  >
                    <_Builtin.Block
                      className={_utils.cx(_styles, "combine-faq1_title")}
                      tag="div"
                    >
                      {
                        "How do I join the EngineEars platform to start offering my services?"
                      }
                    </_Builtin.Block>
                    <_Builtin.Block
                      className={_utils.cx(_styles, "combine-faq1_expander")}
                      tag="div"
                    >
                      <_Builtin.Block
                        className={_utils.cx(_styles, "combine-icon_color4")}
                        tag="div"
                      >
                        <_Builtin.HtmlEmbed
                          className={_utils.cx(_styles, "combine-icon_small")}
                          value="%3Csvg%20width%3D%22currentWidth%22%20height%3D%22currentHeight%22%20viewBox%3D%220%200%2016%2016%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%0A%3Cg%20clip-path%3D%22url(%23clip0_677_666)%22%3E%0A%3Cpath%20d%3D%22M8%201.77777V14.2222%22%20stroke%3D%22currentColor%22%20stroke-width%3D%222%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%0A%3Cpath%20d%3D%22M1.77783%208H14.2223%22%20stroke%3D%22currentColor%22%20stroke-width%3D%222%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%0A%3C%2Fg%3E%0A%3Cdefs%3E%0A%3CclipPath%20id%3D%22clip0_677_666%22%3E%0A%3Crect%20width%3D%2216%22%20height%3D%2216%22%20fill%3D%22currentColor%22%2F%3E%0A%3C%2FclipPath%3E%0A%3C%2Fdefs%3E%0A%3C%2Fsvg%3E"
                        />
                      </_Builtin.Block>
                    </_Builtin.Block>
                  </_Builtin.Block>
                  <_Builtin.Block
                    className={_utils.cx(_styles, "combine-faq1_answer")}
                    tag="div"
                  >
                    <_Builtin.Paragraph
                      className={_utils.cx(_styles, "faq-subtext")}
                    >
                      <_Builtin.Link
                        button={false}
                        block=""
                        options={{
                          href: "#",
                        }}
                      >
                        {"Sign up"}
                      </_Builtin.Link>
                      {
                        " for an account and select the Engineer profile type. Depending on the size of the waitlist, you may be asked to patiently wait before your account is ready for onboarding. If you are not waitlisted, you can freely set up your account to start listing your services right away."
                      }
                    </_Builtin.Paragraph>
                    <_Builtin.Block
                      className={_utils.cx(_styles, "combine-space-medium-2")}
                      tag="div"
                    />
                  </_Builtin.Block>
                </_Builtin.Block>
                <_Builtin.Block
                  className={_utils.cx(_styles, "combine-faq1_accordion")}
                  id={_utils.cx(
                    _styles,
                    "w-node-_2c048298-597e-90dd-8b61-17a774195522-741953c4"
                  )}
                  tag="div"
                >
                  <_Builtin.Block
                    className={_utils.cx(_styles, "combine-faq1_question")}
                    tag="div"
                  >
                    <_Builtin.Block
                      className={_utils.cx(_styles, "combine-faq1_title")}
                      tag="div"
                    >
                      {
                        "How much does it cost to list my services on EngineEars?"
                      }
                    </_Builtin.Block>
                    <_Builtin.Block
                      className={_utils.cx(_styles, "combine-faq1_expander")}
                      tag="div"
                    >
                      <_Builtin.Block
                        className={_utils.cx(_styles, "combine-icon_color4")}
                        tag="div"
                      >
                        <_Builtin.HtmlEmbed
                          className={_utils.cx(_styles, "combine-icon_small")}
                          value="%3Csvg%20width%3D%22currentWidth%22%20height%3D%22currentHeight%22%20viewBox%3D%220%200%2016%2016%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%0A%3Cg%20clip-path%3D%22url(%23clip0_677_666)%22%3E%0A%3Cpath%20d%3D%22M8%201.77777V14.2222%22%20stroke%3D%22currentColor%22%20stroke-width%3D%222%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%0A%3Cpath%20d%3D%22M1.77783%208H14.2223%22%20stroke%3D%22currentColor%22%20stroke-width%3D%222%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%0A%3C%2Fg%3E%0A%3Cdefs%3E%0A%3CclipPath%20id%3D%22clip0_677_666%22%3E%0A%3Crect%20width%3D%2216%22%20height%3D%2216%22%20fill%3D%22currentColor%22%2F%3E%0A%3C%2FclipPath%3E%0A%3C%2Fdefs%3E%0A%3C%2Fsvg%3E"
                        />
                      </_Builtin.Block>
                    </_Builtin.Block>
                  </_Builtin.Block>
                  <_Builtin.Block
                    className={_utils.cx(_styles, "combine-faq1_answer")}
                    tag="div"
                  >
                    <_Builtin.Paragraph
                      className={_utils.cx(_styles, "faq-subtext")}
                    >
                      {
                        "The EngineEars platform does not charge any fees to list services on the marketplace. Free account members incur a 10% service fee every time a listed service is booked on the platform. "
                      }
                      <_Builtin.Link
                        button={false}
                        block=""
                        options={{
                          href: "#",
                        }}
                      >
                        {"Paid account members"}
                      </_Builtin.Link>
                      {
                        " do not incur any service fees on service booking transactions."
                      }
                    </_Builtin.Paragraph>
                    <_Builtin.Block
                      className={_utils.cx(_styles, "combine-space-medium-2")}
                      tag="div"
                    />
                  </_Builtin.Block>
                </_Builtin.Block>
                <_Builtin.Block
                  className={_utils.cx(_styles, "combine-faq1_accordion")}
                  id={_utils.cx(
                    _styles,
                    "w-node-_2c048298-597e-90dd-8b61-17a774195530-741953c4"
                  )}
                  tag="div"
                >
                  <_Builtin.Block
                    className={_utils.cx(_styles, "combine-faq1_question")}
                    tag="div"
                  >
                    <_Builtin.Block
                      className={_utils.cx(_styles, "combine-faq1_title")}
                      tag="div"
                    >
                      {"What types of services can I offer on EngineEars?"}
                    </_Builtin.Block>
                    <_Builtin.Block
                      className={_utils.cx(_styles, "combine-faq1_expander")}
                      tag="div"
                    >
                      <_Builtin.Block
                        className={_utils.cx(_styles, "combine-icon_color4")}
                        tag="div"
                      >
                        <_Builtin.HtmlEmbed
                          className={_utils.cx(_styles, "combine-icon_small")}
                          value="%3Csvg%20width%3D%22currentWidth%22%20height%3D%22currentHeight%22%20viewBox%3D%220%200%2016%2016%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%0A%3Cg%20clip-path%3D%22url(%23clip0_677_666)%22%3E%0A%3Cpath%20d%3D%22M8%201.77777V14.2222%22%20stroke%3D%22currentColor%22%20stroke-width%3D%222%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%0A%3Cpath%20d%3D%22M1.77783%208H14.2223%22%20stroke%3D%22currentColor%22%20stroke-width%3D%222%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%0A%3C%2Fg%3E%0A%3Cdefs%3E%0A%3CclipPath%20id%3D%22clip0_677_666%22%3E%0A%3Crect%20width%3D%2216%22%20height%3D%2216%22%20fill%3D%22currentColor%22%2F%3E%0A%3C%2FclipPath%3E%0A%3C%2Fdefs%3E%0A%3C%2Fsvg%3E"
                        />
                      </_Builtin.Block>
                    </_Builtin.Block>
                  </_Builtin.Block>
                  <_Builtin.Block
                    className={_utils.cx(_styles, "combine-faq1_answer")}
                    tag="div"
                  >
                    <_Builtin.Paragraph
                      className={_utils.cx(_styles, "faq-subtext")}
                    >
                      {
                        "The standard services you can choose to offer are: 2-Track Mix, Full-Stem Mix, Dolby Atmos Mix (if certified), Mastering, and/or Recording. Artists can book any individual or combination of these services that you list on your account profile."
                      }
                    </_Builtin.Paragraph>
                    <_Builtin.Block
                      className={_utils.cx(_styles, "combine-space-medium-2")}
                      tag="div"
                    />
                  </_Builtin.Block>
                </_Builtin.Block>
                <_Builtin.Block
                  className={_utils.cx(_styles, "combine-faq1_accordion")}
                  id={_utils.cx(
                    _styles,
                    "w-node-_2c048298-597e-90dd-8b61-17a77419553b-741953c4"
                  )}
                  tag="div"
                >
                  <_Builtin.Block
                    className={_utils.cx(_styles, "combine-faq1_question")}
                    tag="div"
                  >
                    <_Builtin.Block
                      className={_utils.cx(_styles, "combine-faq1_title")}
                      tag="div"
                    >
                      {"Do I have to be a paid member to offer my services?"}
                    </_Builtin.Block>
                    <_Builtin.Block
                      className={_utils.cx(_styles, "combine-faq1_expander")}
                      tag="div"
                    >
                      <_Builtin.Block
                        className={_utils.cx(_styles, "combine-icon_color4")}
                        tag="div"
                      >
                        <_Builtin.HtmlEmbed
                          className={_utils.cx(_styles, "combine-icon_small")}
                          value="%3Csvg%20width%3D%22currentWidth%22%20height%3D%22currentHeight%22%20viewBox%3D%220%200%2016%2016%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%0A%3Cg%20clip-path%3D%22url(%23clip0_677_666)%22%3E%0A%3Cpath%20d%3D%22M8%201.77777V14.2222%22%20stroke%3D%22currentColor%22%20stroke-width%3D%222%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%0A%3Cpath%20d%3D%22M1.77783%208H14.2223%22%20stroke%3D%22currentColor%22%20stroke-width%3D%222%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%0A%3C%2Fg%3E%0A%3Cdefs%3E%0A%3CclipPath%20id%3D%22clip0_677_666%22%3E%0A%3Crect%20width%3D%2216%22%20height%3D%2216%22%20fill%3D%22currentColor%22%2F%3E%0A%3C%2FclipPath%3E%0A%3C%2Fdefs%3E%0A%3C%2Fsvg%3E"
                        />
                      </_Builtin.Block>
                    </_Builtin.Block>
                  </_Builtin.Block>
                  <_Builtin.Block
                    className={_utils.cx(_styles, "combine-faq1_answer")}
                    tag="div"
                  >
                    <_Builtin.Paragraph
                      className={_utils.cx(_styles, "faq-subtext")}
                    >
                      {"No. You can "}
                      <_Builtin.Link
                        button={false}
                        block=""
                        options={{
                          href: "#",
                        }}
                      >
                        {"join EngineEars"}
                      </_Builtin.Link>
                      {
                        " as a free account member in order to offer your services. However, paid account members enjoy a vast array of benefits from the platform and community. Learn more about our different "
                      }
                      <_Builtin.Link
                        button={false}
                        block=""
                        options={{
                          href: "#",
                        }}
                      >
                        {"Membership Plans"}
                      </_Builtin.Link>
                      {
                        " and their feature benefits to decide what is best for you."
                      }
                    </_Builtin.Paragraph>
                    <_Builtin.Block
                      className={_utils.cx(_styles, "combine-space-medium-2")}
                      tag="div"
                    />
                  </_Builtin.Block>
                </_Builtin.Block>
                <_Builtin.Block
                  className={_utils.cx(_styles, "combine-faq1_accordion")}
                  id={_utils.cx(
                    _styles,
                    "w-node-_2c048298-597e-90dd-8b61-17a77419554c-741953c4"
                  )}
                  tag="div"
                >
                  <_Builtin.Block
                    className={_utils.cx(_styles, "combine-faq1_question")}
                    tag="div"
                  >
                    <_Builtin.Block
                      className={_utils.cx(_styles, "combine-faq1_title")}
                      tag="div"
                    >
                      {"How much file storage is provided with an account?"}
                    </_Builtin.Block>
                    <_Builtin.Block
                      className={_utils.cx(_styles, "combine-faq1_expander")}
                      tag="div"
                    >
                      <_Builtin.Block
                        className={_utils.cx(_styles, "combine-icon_color4")}
                        tag="div"
                      >
                        <_Builtin.HtmlEmbed
                          className={_utils.cx(_styles, "combine-icon_small")}
                          value="%3Csvg%20width%3D%22currentWidth%22%20height%3D%22currentHeight%22%20viewBox%3D%220%200%2016%2016%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%0A%3Cg%20clip-path%3D%22url(%23clip0_677_666)%22%3E%0A%3Cpath%20d%3D%22M8%201.77777V14.2222%22%20stroke%3D%22currentColor%22%20stroke-width%3D%222%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%0A%3Cpath%20d%3D%22M1.77783%208H14.2223%22%20stroke%3D%22currentColor%22%20stroke-width%3D%222%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%0A%3C%2Fg%3E%0A%3Cdefs%3E%0A%3CclipPath%20id%3D%22clip0_677_666%22%3E%0A%3Crect%20width%3D%2216%22%20height%3D%2216%22%20fill%3D%22currentColor%22%2F%3E%0A%3C%2FclipPath%3E%0A%3C%2Fdefs%3E%0A%3C%2Fsvg%3E"
                        />
                      </_Builtin.Block>
                    </_Builtin.Block>
                  </_Builtin.Block>
                  <_Builtin.Block
                    className={_utils.cx(_styles, "combine-faq1_answer")}
                    tag="div"
                  >
                    <_Builtin.Paragraph
                      className={_utils.cx(_styles, "faq-subtext")}
                    >
                      {
                        "Free account members receive up to 1TB of secure file storage. Paid account members have unlimited secure file storage."
                      }
                    </_Builtin.Paragraph>
                    <_Builtin.Block
                      className={_utils.cx(_styles, "combine-space-medium-2")}
                      tag="div"
                    />
                  </_Builtin.Block>
                </_Builtin.Block>
                <_Builtin.Block
                  className={_utils.cx(_styles, "combine-faq1_accordion")}
                  id={_utils.cx(
                    _styles,
                    "w-node-_2c048298-597e-90dd-8b61-17a774195557-741953c4"
                  )}
                  tag="div"
                >
                  <_Builtin.Block
                    className={_utils.cx(_styles, "combine-faq1_question")}
                    tag="div"
                  >
                    <_Builtin.Block
                      className={_utils.cx(_styles, "combine-faq1_title")}
                      tag="div"
                    >
                      {"How quickly can I get paid for my work?"}
                    </_Builtin.Block>
                    <_Builtin.Block
                      className={_utils.cx(_styles, "combine-faq1_expander")}
                      tag="div"
                    >
                      <_Builtin.Block
                        className={_utils.cx(_styles, "combine-icon_color4")}
                        tag="div"
                      >
                        <_Builtin.HtmlEmbed
                          className={_utils.cx(_styles, "combine-icon_small")}
                          value="%3Csvg%20width%3D%22currentWidth%22%20height%3D%22currentHeight%22%20viewBox%3D%220%200%2016%2016%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%0A%3Cg%20clip-path%3D%22url(%23clip0_677_666)%22%3E%0A%3Cpath%20d%3D%22M8%201.77777V14.2222%22%20stroke%3D%22currentColor%22%20stroke-width%3D%222%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%0A%3Cpath%20d%3D%22M1.77783%208H14.2223%22%20stroke%3D%22currentColor%22%20stroke-width%3D%222%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%0A%3C%2Fg%3E%0A%3Cdefs%3E%0A%3CclipPath%20id%3D%22clip0_677_666%22%3E%0A%3Crect%20width%3D%2216%22%20height%3D%2216%22%20fill%3D%22currentColor%22%2F%3E%0A%3C%2FclipPath%3E%0A%3C%2Fdefs%3E%0A%3C%2Fsvg%3E"
                        />
                      </_Builtin.Block>
                    </_Builtin.Block>
                  </_Builtin.Block>
                  <_Builtin.Block
                    className={_utils.cx(_styles, "combine-faq1_answer")}
                    tag="div"
                  >
                    <_Builtin.Paragraph
                      className={_utils.cx(_styles, "faq-subtext")}
                    >
                      {
                        "As soon as you complete a project or session, you will be paid. Collected funds from artists and label clients are securely held in escrow until the completion of a project or session, then they are immediately released to your account. Instead of chasing payments or waiting due to net-30 payment terms, you get net-0 payouts automatically so you can focus on delivering quality work."
                      }
                    </_Builtin.Paragraph>
                    <_Builtin.Block
                      className={_utils.cx(_styles, "combine-space-medium-2")}
                      tag="div"
                    />
                  </_Builtin.Block>
                </_Builtin.Block>
              </_Builtin.Block>
            </_Builtin.Block>
          </_Builtin.Block>
        </_Builtin.BlockContainer>
      </_Builtin.Section>
      <_Builtin.Block
        className={_utils.cx(_styles, "combine-section_blog1")}
        tag="section"
      >
        <_Builtin.Block
          className={_utils.cx(_styles, "combine-padding-global-4")}
          tag="div"
        >
          <_Builtin.Block
            className={_utils.cx(_styles, "combine-padding-section-medium-4")}
            tag="div"
          >
            <_Builtin.Block
              className={_utils.cx(_styles, "combine-container-small-3")}
              tag="div"
            >
              <_Builtin.Block
                className={_utils.cx(_styles, "combine-text-align-center-3")}
                tag="div"
              >
                <_Builtin.Heading
                  className={_utils.cx(_styles, "homepage-h3")}
                  tag="h3"
                >
                  {"Featured Content"}
                </_Builtin.Heading>
                <_Builtin.Block
                  className={_utils.cx(_styles, "combine-space-medium-3")}
                  tag="div"
                />
                <_Builtin.Block
                  className={_utils.cx(_styles, "blogs-subtext")}
                  tag="div"
                >
                  {
                    "Expand your knowledge to level up your career and grow your audio engineering business"
                  }
                </_Builtin.Block>
              </_Builtin.Block>
            </_Builtin.Block>
            <_Builtin.Block
              className={_utils.cx(_styles, "combine-space-large-3")}
              tag="div"
            />
            <_Builtin.Block
              className={_utils.cx(_styles, "combine-container-large-3")}
              tag="div"
            >
              <_Builtin.Block
                className={_utils.cx(_styles, "combine-blog1_component")}
                tag="div"
              >
                <_Builtin.Link
                  className={_utils.cx(_styles, "combine-blog1_item")}
                  button={false}
                  block="inline"
                  options={{
                    href: "https://blog.engineears.com/mastering-money-financial-strategy-for-audio-engineers/",
                  }}
                >
                  <_Builtin.Block
                    className={_utils.cx(
                      _styles,
                      "combine-blog1_image-wrapper"
                    )}
                    tag="div"
                  >
                    <_Builtin.Image
                      className={_utils.cx(_styles, "combine-blog1_image")}
                      loading="lazy"
                      width="auto"
                      height="auto"
                      alt=""
                      src="https://cdn.prod.website-files.com/6356e5735110b93b46145859/67365965540d1a6182069d74_osirisx3_a_digital_audio_workstation_in_a_music_studio.webp"
                    />
                  </_Builtin.Block>
                  <_Builtin.Block
                    className={_utils.cx(_styles, "combine-blog1_content")}
                    tag="div"
                  >
                    <_Builtin.Heading
                      className={_utils.cx(_styles, "combine-heading-style-h5")}
                      tag="h3"
                    >
                      {
                        "Mastering Money: Financial Strategy for Audio Engineers"
                      }
                    </_Builtin.Heading>
                    <_Builtin.Block
                      className={_utils.cx(
                        _styles,
                        "combine-text-size-small",
                        "combine-text-color-grey"
                      )}
                      tag="div"
                    >
                      {
                        "In the world of audio engineering, mastering your craft is only part of the equation for success. Equally important is mastering your finances."
                      }
                    </_Builtin.Block>
                    <_Builtin.Block
                      className={_utils.cx(_styles, "combine-button-icon")}
                      tag="div"
                    >
                      <_Builtin.Block
                        className={_utils.cx(_styles, "combine-button-content")}
                        tag="div"
                      >
                        <_Builtin.Block tag="div">
                          {"Read Article"}
                        </_Builtin.Block>
                        <_Builtin.HtmlEmbed
                          className={_utils.cx(
                            _styles,
                            "combine-chevron-right_icon"
                          )}
                          value="%3Csvg%20width%3D%22100%25%22%20height%3D%22currentHeight%22%20viewBox%3D%220%200%2016%2016%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%0A%3Cpath%20d%3D%22M6.83301%2013L11.833%208L6.83301%203%22%20stroke%3D%22currentColor%22%20stroke-width%3D%222%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%0A%3C%2Fsvg%3E"
                        />
                      </_Builtin.Block>
                    </_Builtin.Block>
                  </_Builtin.Block>
                </_Builtin.Link>
                <_Builtin.Link
                  className={_utils.cx(_styles, "combine-blog1_item")}
                  button={false}
                  block="inline"
                  options={{
                    href: "https://blog.engineears.com/building-clientele-as-an-audio-engineer/",
                  }}
                >
                  <_Builtin.Block
                    className={_utils.cx(
                      _styles,
                      "combine-blog1_image-wrapper"
                    )}
                    tag="div"
                  >
                    <_Builtin.Image
                      className={_utils.cx(_styles, "combine-blog1_image")}
                      loading="lazy"
                      width="auto"
                      height="auto"
                      alt=""
                      src="https://cdn.prod.website-files.com/6356e5735110b93b46145859/6736594b939bdb6a99f298e1_pexels-matthias-groeneveld-4200745-770x470.jpg"
                    />
                  </_Builtin.Block>
                  <_Builtin.Block
                    className={_utils.cx(_styles, "combine-blog1_content")}
                    tag="div"
                  >
                    <_Builtin.Heading
                      className={_utils.cx(_styles, "combine-heading-style-h5")}
                      tag="h3"
                    >
                      {"Building Clientele As An Audio Engineer"}
                    </_Builtin.Heading>
                    <_Builtin.Block
                      className={_utils.cx(
                        _styles,
                        "combine-text-size-small",
                        "combine-text-color-grey"
                      )}
                      tag="div"
                    >
                      {
                        "Building a solid clientele as an audio engineer can be a challenge, but with dedication and effort, this can be achievable. "
                      }
                    </_Builtin.Block>
                    <_Builtin.Block
                      className={_utils.cx(_styles, "combine-button-icon")}
                      tag="div"
                    >
                      <_Builtin.Block
                        className={_utils.cx(_styles, "combine-button-content")}
                        tag="div"
                      >
                        <_Builtin.Block
                          className={_utils.cx(_styles, "")}
                          tag="div"
                        >
                          {"Read Article"}
                        </_Builtin.Block>
                        <_Builtin.HtmlEmbed
                          className={_utils.cx(
                            _styles,
                            "combine-chevron-right_icon"
                          )}
                          value="%3Csvg%20width%3D%22100%25%22%20height%3D%22currentHeight%22%20viewBox%3D%220%200%2016%2016%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%0A%3Cpath%20d%3D%22M6.83301%2013L11.833%208L6.83301%203%22%20stroke%3D%22currentColor%22%20stroke-width%3D%222%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%0A%3C%2Fsvg%3E"
                        />
                      </_Builtin.Block>
                    </_Builtin.Block>
                  </_Builtin.Block>
                </_Builtin.Link>
                <_Builtin.Link
                  className={_utils.cx(_styles, "combine-blog1_item")}
                  button={false}
                  block="inline"
                  options={{
                    href: "https://blog.engineears.com/mix-fees-what-do-i-charge/",
                  }}
                >
                  <_Builtin.Block
                    className={_utils.cx(
                      _styles,
                      "combine-blog1_image-wrapper"
                    )}
                    tag="div"
                  >
                    <_Builtin.Image
                      className={_utils.cx(_styles, "combine-blog1_image")}
                      loading="lazy"
                      width="auto"
                      height="auto"
                      alt=""
                      src="https://cdn.prod.website-files.com/6356e5735110b93b46145859/6736594b2d01c43157dc086a_pexels-daniel-kondrashin-12889652-770x470.jpg"
                    />
                  </_Builtin.Block>
                  <_Builtin.Block
                    className={_utils.cx(_styles, "combine-blog1_content")}
                    tag="div"
                  >
                    <_Builtin.Heading
                      className={_utils.cx(_styles, "combine-heading-style-h5")}
                      tag="h3"
                    >
                      {"Mix Fees: What Do I Charge?"}
                    </_Builtin.Heading>
                    <_Builtin.Block
                      className={_utils.cx(
                        _styles,
                        "combine-text-size-small",
                        "combine-text-color-grey"
                      )}
                      tag="div"
                    >
                      {
                        "For many indie musicians and producers, a hefty production budget is just not in the cards. But here’s the thing: investing in your craft is key if you’re serious about forging a long-lasting career."
                      }
                    </_Builtin.Block>
                    <_Builtin.Block
                      className={_utils.cx(_styles, "combine-button-icon")}
                      tag="div"
                    >
                      <_Builtin.Block
                        className={_utils.cx(_styles, "combine-button-content")}
                        tag="div"
                      >
                        <_Builtin.Block tag="div">
                          {"Read Article"}
                        </_Builtin.Block>
                        <_Builtin.HtmlEmbed
                          className={_utils.cx(
                            _styles,
                            "combine-chevron-right_icon"
                          )}
                          value="%3Csvg%20width%3D%22100%25%22%20height%3D%22currentHeight%22%20viewBox%3D%220%200%2016%2016%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%0A%3Cpath%20d%3D%22M6.83301%2013L11.833%208L6.83301%203%22%20stroke%3D%22currentColor%22%20stroke-width%3D%222%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%0A%3C%2Fsvg%3E"
                        />
                      </_Builtin.Block>
                    </_Builtin.Block>
                  </_Builtin.Block>
                </_Builtin.Link>
              </_Builtin.Block>
            </_Builtin.Block>
            <_Builtin.BlockContainer
              className={_utils.cx(
                _styles,
                "homepage-container",
                "button-wrapper"
              )}
              grid={{
                type: "container",
              }}
              tag="div"
            >
              <_Builtin.Link
                className={_utils.cx(
                  _styles,
                  "engineears-button",
                  "centered-button"
                )}
                button={true}
                block=""
                options={{
                  href: "http://blog.engineears.com",
                }}
              >
                {"View More"}
              </_Builtin.Link>
            </_Builtin.BlockContainer>
          </_Builtin.Block>
        </_Builtin.Block>
      </_Builtin.Block>
      <_Builtin.Block
        className={_utils.cx(_styles, "combine-section_cta3")}
        tag="section"
      >
        <_Builtin.Block
          className={_utils.cx(_styles, "combine-padding-global-6")}
          tag="div"
        >
          <_Builtin.Block
            className={_utils.cx(_styles, "combine-padding-section-large-2")}
            tag="div"
          >
            <_Builtin.Block
              className={_utils.cx(_styles, "combine-container-large-5")}
              tag="div"
            >
              <_Builtin.Block
                className={_utils.cx(_styles, "combine-cta3_component")}
                tag="div"
              >
                <_Builtin.Block
                  className={_utils.cx(_styles, "combine-container-small-4")}
                  tag="div"
                >
                  <_Builtin.Block
                    className={_utils.cx(
                      _styles,
                      "combine-text-align-center-4"
                    )}
                    tag="div"
                  >
                    <_Builtin.Block
                      className={_utils.cx(_styles, "div-block-112")}
                      tag="div"
                    >
                      <_Builtin.Heading
                        className={_utils.cx(_styles, "combine-cta3_title")}
                        tag="h2"
                      >
                        {"Ready to streamline your "}
                        <br />
                        {"audio engineering business?"}
                      </_Builtin.Heading>
                      <_Builtin.Block
                        className={_utils.cx(
                          _styles,
                          "combine-text-color-white"
                        )}
                        tag="div"
                      >
                        {"Sign up to EngineEars today!"}
                      </_Builtin.Block>
                    </_Builtin.Block>
                    <_Builtin.Block
                      className={_utils.cx(_styles, "combine-button-wrapper-4")}
                      tag="div"
                    >
                      <_Builtin.Link
                        className={_utils.cx(
                          _styles,
                          "engineears-button-black"
                        )}
                        button={true}
                        block=""
                        options={{
                          href: "https://engineears.com/signup?flow=6&step=3",
                        }}
                      >
                        {"Sign Up for Free"}
                      </_Builtin.Link>
                    </_Builtin.Block>
                  </_Builtin.Block>
                </_Builtin.Block>
              </_Builtin.Block>
            </_Builtin.Block>
          </_Builtin.Block>
        </_Builtin.Block>
      </_Builtin.Block>
      <_Builtin.Section
        className={_utils.cx(_styles, "homepage-section")}
        grid={{
          type: "section",
        }}
        tag="section"
      >
        <_Builtin.BlockContainer
          className={_utils.cx(_styles, "homepage-container")}
          grid={{
            type: "container",
          }}
          tag="div"
        >
          <_Builtin.Block
            className={_utils.cx(_styles, "combine-section_clients4")}
            tag="section"
          >
            <_Builtin.Block
              className={_utils.cx(_styles, "combine-padding-global-7")}
              tag="div"
            >
              <_Builtin.Block
                className={_utils.cx(
                  _styles,
                  "combine-padding-section-medium-6"
                )}
                tag="div"
              >
                <_Builtin.Block
                  className={_utils.cx(_styles, "combine-container-small-5")}
                  tag="div"
                >
                  <_Builtin.Block
                    className={_utils.cx(
                      _styles,
                      "combine-text-align-center-5"
                    )}
                    tag="div"
                  >
                    <_Builtin.Heading
                      className={_utils.cx(_styles, "homepage-h2")}
                      tag="h2"
                    >
                      {"What Our Artists Have To Say"}
                      <br />
                    </_Builtin.Heading>
                    <_Builtin.Block
                      className={_utils.cx(_styles, "combine-space-medium-5")}
                      tag="div"
                    />
                  </_Builtin.Block>
                </_Builtin.Block>
                <_Builtin.Block
                  className={_utils.cx(_styles, "combine-space-large-4")}
                  tag="div"
                />
                <_Builtin.Block
                  className={_utils.cx(_styles, "combine-container-large-6")}
                  tag="div"
                >
                  <_Builtin.Block
                    className={_utils.cx(_styles, "combine-clients4_grid-2")}
                    tag="div"
                  >
                    <_Builtin.Block
                      className={_utils.cx(_styles, "combine-clients4_grid")}
                      id={_utils.cx(
                        _styles,
                        "w-node-f6440dac-a022-97c9-f58b-2e42c6d03486-741953c4"
                      )}
                      tag="div"
                    >
                      <_Builtin.Block
                        className={_utils.cx(
                          _styles,
                          "combine-clients4_wrapper"
                        )}
                        id={_utils.cx(
                          _styles,
                          "w-node-f6440dac-a022-97c9-f58b-2e42c6d03487-741953c4"
                        )}
                        tag="div"
                      >
                        <_Builtin.Block
                          className={_utils.cx(
                            _styles,
                            "combine-clients4_item"
                          )}
                          tag="div"
                        >
                          <_Builtin.RichText tag="div">
                            <_Builtin.Paragraph>
                              {
                                '"It\'s a great way for new engineers to build clients and the platform is very easy to communicate with artist , book and keep track of projects"'
                              }
                            </_Builtin.Paragraph>
                          </_Builtin.RichText>
                          <_Builtin.Block
                            className={_utils.cx(
                              _styles,
                              "combine-clients4_client"
                            )}
                            tag="div"
                          >
                            <_Builtin.Block
                              className={_utils.cx(_styles, "div-block-114")}
                              id={_utils.cx(
                                _styles,
                                "w-node-f6440dac-a022-97c9-f58b-2e42c6d0348d-741953c4"
                              )}
                              tag="div"
                            >
                              <_Builtin.Block
                                className={_utils.cx(_styles, "qt-client-name")}
                                id={_utils.cx(
                                  _styles,
                                  "w-node-f6440dac-a022-97c9-f58b-2e42c6d0348e-741953c4"
                                )}
                                tag="div"
                              >
                                {"Owen K."}
                              </_Builtin.Block>
                              <_Builtin.Block
                                className={_utils.cx(_styles, "qt-subtext-2")}
                                id={_utils.cx(
                                  _styles,
                                  "w-node-f6440dac-a022-97c9-f58b-2e42c6d03490-741953c4"
                                )}
                                tag="div"
                              >
                                {"Engineer"}
                              </_Builtin.Block>
                            </_Builtin.Block>
                            <_Builtin.Block
                              className={_utils.cx(
                                _styles,
                                "combine-clients4_image-wrapper"
                              )}
                              tag="div"
                            >
                              <_Builtin.Block
                                className={_utils.cx(_styles, "text-block-44")}
                                tag="div"
                              >
                                {"O"}
                              </_Builtin.Block>
                            </_Builtin.Block>
                          </_Builtin.Block>
                        </_Builtin.Block>
                      </_Builtin.Block>
                      <_Builtin.Block
                        className={_utils.cx(
                          _styles,
                          "combine-clients4_wrapper"
                        )}
                        id={_utils.cx(
                          _styles,
                          "w-node-f6440dac-a022-97c9-f58b-2e42c6d03495-741953c4"
                        )}
                        tag="div"
                      >
                        <_Builtin.Block
                          className={_utils.cx(
                            _styles,
                            "combine-clients4_item"
                          )}
                          tag="div"
                        >
                          <_Builtin.RichText tag="div">
                            <_Builtin.Paragraph>
                              {
                                '"I love EngineEars, it’s a great community with amazing tools. It also makes running my business easy and efficient"'
                              }
                            </_Builtin.Paragraph>
                          </_Builtin.RichText>
                          <_Builtin.Block
                            className={_utils.cx(
                              _styles,
                              "combine-clients4_client"
                            )}
                            tag="div"
                          >
                            <_Builtin.Block
                              className={_utils.cx(_styles, "div-block-114")}
                              id={_utils.cx(
                                _styles,
                                "w-node-f6440dac-a022-97c9-f58b-2e42c6d0349b-741953c4"
                              )}
                              tag="div"
                            >
                              <_Builtin.Block
                                className={_utils.cx(_styles, "qt-client-name")}
                                id={_utils.cx(
                                  _styles,
                                  "w-node-f6440dac-a022-97c9-f58b-2e42c6d0349c-741953c4"
                                )}
                                tag="div"
                              >
                                {"Tanaja H."}
                              </_Builtin.Block>
                              <_Builtin.Block
                                className={_utils.cx(_styles, "qt-subtext-2")}
                                id={_utils.cx(
                                  _styles,
                                  "w-node-f6440dac-a022-97c9-f58b-2e42c6d0349e-741953c4"
                                )}
                                tag="div"
                              >
                                {"Engineer"}
                              </_Builtin.Block>
                            </_Builtin.Block>
                            <_Builtin.Block
                              className={_utils.cx(
                                _styles,
                                "combine-clients4_image-wrapper"
                              )}
                              tag="div"
                            >
                              <_Builtin.Block
                                className={_utils.cx(_styles, "text-block-44")}
                                tag="div"
                              >
                                {"T"}
                              </_Builtin.Block>
                            </_Builtin.Block>
                          </_Builtin.Block>
                        </_Builtin.Block>
                      </_Builtin.Block>
                    </_Builtin.Block>
                    <_Builtin.Block
                      className={_utils.cx(_styles, "combine-clients4_grid")}
                      id={_utils.cx(
                        _styles,
                        "w-node-f6440dac-a022-97c9-f58b-2e42c6d034a3-741953c4"
                      )}
                      tag="div"
                    >
                      <_Builtin.Block
                        className={_utils.cx(
                          _styles,
                          "combine-clients4_wrapper"
                        )}
                        id={_utils.cx(
                          _styles,
                          "w-node-f6440dac-a022-97c9-f58b-2e42c6d034a4-741953c4"
                        )}
                        tag="div"
                      >
                        <_Builtin.Block
                          className={_utils.cx(
                            _styles,
                            "combine-clients4_item"
                          )}
                          tag="div"
                        >
                          <_Builtin.RichText tag="div">
                            <_Builtin.Paragraph>
                              {
                                '"EngineEars gives us Audio engineers a new approach to how we can handle business in a professional manner !!"'
                              }
                            </_Builtin.Paragraph>
                          </_Builtin.RichText>
                          <_Builtin.Block
                            className={_utils.cx(
                              _styles,
                              "combine-clients4_client"
                            )}
                            tag="div"
                          >
                            <_Builtin.Block
                              className={_utils.cx(_styles, "div-block-114")}
                              id={_utils.cx(
                                _styles,
                                "w-node-f6440dac-a022-97c9-f58b-2e42c6d034aa-741953c4"
                              )}
                              tag="div"
                            >
                              <_Builtin.Block
                                className={_utils.cx(_styles, "qt-client-name")}
                                id={_utils.cx(
                                  _styles,
                                  "w-node-f6440dac-a022-97c9-f58b-2e42c6d034ab-741953c4"
                                )}
                                tag="div"
                              >
                                {"Taylor C."}
                              </_Builtin.Block>
                              <_Builtin.Block
                                className={_utils.cx(_styles, "qt-subtext-2")}
                                id={_utils.cx(
                                  _styles,
                                  "w-node-f6440dac-a022-97c9-f58b-2e42c6d034ad-741953c4"
                                )}
                                tag="div"
                              >
                                {"Engineer"}
                              </_Builtin.Block>
                            </_Builtin.Block>
                            <_Builtin.Block
                              className={_utils.cx(
                                _styles,
                                "combine-clients4_image-wrapper"
                              )}
                              tag="div"
                            >
                              <_Builtin.Block
                                className={_utils.cx(_styles, "text-block-44")}
                                tag="div"
                              >
                                <_Builtin.Strong>{"T"}</_Builtin.Strong>
                              </_Builtin.Block>
                            </_Builtin.Block>
                          </_Builtin.Block>
                        </_Builtin.Block>
                      </_Builtin.Block>
                      <_Builtin.Block
                        className={_utils.cx(
                          _styles,
                          "combine-clients4_wrapper"
                        )}
                        id={_utils.cx(
                          _styles,
                          "w-node-f6440dac-a022-97c9-f58b-2e42c6d034b3-741953c4"
                        )}
                        tag="div"
                      >
                        <_Builtin.Block
                          className={_utils.cx(
                            _styles,
                            "combine-clients4_item"
                          )}
                          tag="div"
                        >
                          <_Builtin.RichText tag="div">
                            <_Builtin.Paragraph>
                              {
                                '"Truly takes a lot of the stress of booking and communication off of both myself and the client. Really fluid!"'
                              }
                            </_Builtin.Paragraph>
                          </_Builtin.RichText>
                          <_Builtin.Block
                            className={_utils.cx(
                              _styles,
                              "combine-clients4_client"
                            )}
                            tag="div"
                          >
                            <_Builtin.Block
                              className={_utils.cx(_styles, "div-block-114")}
                              id={_utils.cx(
                                _styles,
                                "w-node-f6440dac-a022-97c9-f58b-2e42c6d034b9-741953c4"
                              )}
                              tag="div"
                            >
                              <_Builtin.Block
                                className={_utils.cx(_styles, "qt-client-name")}
                                id={_utils.cx(
                                  _styles,
                                  "w-node-f6440dac-a022-97c9-f58b-2e42c6d034ba-741953c4"
                                )}
                                tag="div"
                              >
                                {"Lionel R."}
                              </_Builtin.Block>
                              <_Builtin.Block
                                className={_utils.cx(_styles, "qt-subtext-2")}
                                id={_utils.cx(
                                  _styles,
                                  "w-node-f6440dac-a022-97c9-f58b-2e42c6d034bc-741953c4"
                                )}
                                tag="div"
                              >
                                {"Engineer"}
                              </_Builtin.Block>
                            </_Builtin.Block>
                            <_Builtin.Block
                              className={_utils.cx(
                                _styles,
                                "combine-clients4_image-wrapper"
                              )}
                              tag="div"
                            >
                              <_Builtin.Block
                                className={_utils.cx(_styles, "text-block-44")}
                                tag="div"
                              >
                                {"L"}
                              </_Builtin.Block>
                            </_Builtin.Block>
                          </_Builtin.Block>
                        </_Builtin.Block>
                      </_Builtin.Block>
                    </_Builtin.Block>
                    <_Builtin.Block
                      className={_utils.cx(_styles, "combine-clients4_grid")}
                      id={_utils.cx(
                        _styles,
                        "w-node-f6440dac-a022-97c9-f58b-2e42c6d034c1-741953c4"
                      )}
                      tag="div"
                    >
                      <_Builtin.Block
                        className={_utils.cx(
                          _styles,
                          "combine-clients4_wrapper"
                        )}
                        id={_utils.cx(
                          _styles,
                          "w-node-f6440dac-a022-97c9-f58b-2e42c6d034c2-741953c4"
                        )}
                        tag="div"
                      >
                        <_Builtin.Block
                          className={_utils.cx(
                            _styles,
                            "combine-clients4_item"
                          )}
                          tag="div"
                        >
                          <_Builtin.RichText tag="div">
                            <_Builtin.Paragraph>
                              {
                                '"Engineears has helped me advance in my career with the Dolby Atmos Course."'
                              }
                            </_Builtin.Paragraph>
                          </_Builtin.RichText>
                          <_Builtin.Block
                            className={_utils.cx(
                              _styles,
                              "combine-clients4_client"
                            )}
                            tag="div"
                          >
                            <_Builtin.Block
                              className={_utils.cx(_styles, "div-block-114")}
                              id={_utils.cx(
                                _styles,
                                "w-node-f6440dac-a022-97c9-f58b-2e42c6d034c8-741953c4"
                              )}
                              tag="div"
                            >
                              <_Builtin.Block
                                className={_utils.cx(_styles, "qt-client-name")}
                                id={_utils.cx(
                                  _styles,
                                  "w-node-f6440dac-a022-97c9-f58b-2e42c6d034c9-741953c4"
                                )}
                                tag="div"
                              >
                                {"Laguil Z."}
                              </_Builtin.Block>
                              <_Builtin.Block
                                className={_utils.cx(_styles, "qt-subtext-2")}
                                id={_utils.cx(
                                  _styles,
                                  "w-node-f6440dac-a022-97c9-f58b-2e42c6d034cb-741953c4"
                                )}
                                tag="div"
                              >
                                {"Engineer"}
                              </_Builtin.Block>
                            </_Builtin.Block>
                            <_Builtin.Block
                              className={_utils.cx(
                                _styles,
                                "combine-clients4_image-wrapper"
                              )}
                              tag="div"
                            >
                              <_Builtin.Block
                                className={_utils.cx(_styles, "text-block-44")}
                                tag="div"
                              >
                                {"L"}
                              </_Builtin.Block>
                            </_Builtin.Block>
                          </_Builtin.Block>
                        </_Builtin.Block>
                      </_Builtin.Block>
                      <_Builtin.Block
                        className={_utils.cx(
                          _styles,
                          "combine-clients4_wrapper"
                        )}
                        id={_utils.cx(
                          _styles,
                          "w-node-f6440dac-a022-97c9-f58b-2e42c6d034d0-741953c4"
                        )}
                        tag="div"
                      >
                        <_Builtin.Block
                          className={_utils.cx(
                            _styles,
                            "combine-clients4_item"
                          )}
                          tag="div"
                        >
                          <_Builtin.RichText tag="div">
                            <_Builtin.Paragraph>
                              {
                                '"EngineEars makes the lives of artists and engineers easier, simplifying just about every problem known to man when it comes to handling studio sessions, mixes and masters."'
                              }
                            </_Builtin.Paragraph>
                          </_Builtin.RichText>
                          <_Builtin.Block
                            className={_utils.cx(
                              _styles,
                              "combine-clients4_client"
                            )}
                            tag="div"
                          >
                            <_Builtin.Block
                              className={_utils.cx(_styles, "div-block-114")}
                              id={_utils.cx(
                                _styles,
                                "w-node-f6440dac-a022-97c9-f58b-2e42c6d034d6-741953c4"
                              )}
                              tag="div"
                            >
                              <_Builtin.Block
                                className={_utils.cx(_styles, "qt-client-name")}
                                id={_utils.cx(
                                  _styles,
                                  "w-node-f6440dac-a022-97c9-f58b-2e42c6d034d7-741953c4"
                                )}
                                tag="div"
                              >
                                {"Jarrod-Michael W."}
                              </_Builtin.Block>
                              <_Builtin.Block
                                className={_utils.cx(_styles, "qt-subtext-2")}
                                id={_utils.cx(
                                  _styles,
                                  "w-node-f6440dac-a022-97c9-f58b-2e42c6d034d9-741953c4"
                                )}
                                tag="div"
                              >
                                {"Engineer"}
                              </_Builtin.Block>
                            </_Builtin.Block>
                            <_Builtin.Block
                              className={_utils.cx(
                                _styles,
                                "combine-clients4_image-wrapper"
                              )}
                              tag="div"
                            >
                              <_Builtin.Block
                                className={_utils.cx(_styles, "text-block-44")}
                                tag="div"
                              >
                                {"J"}
                              </_Builtin.Block>
                            </_Builtin.Block>
                          </_Builtin.Block>
                        </_Builtin.Block>
                      </_Builtin.Block>
                    </_Builtin.Block>
                  </_Builtin.Block>
                </_Builtin.Block>
              </_Builtin.Block>
            </_Builtin.Block>
          </_Builtin.Block>
        </_Builtin.BlockContainer>
      </_Builtin.Section>
      <_Builtin.Section
        className={_utils.cx(_styles, "waves---section-medium-12")}
        grid={{
          type: "section",
        }}
        tag="div"
      >
        <_Builtin.Container
          className={_utils.cx(_styles, "waves---main-container-18")}
          tag="div"
        >
          <_Builtin.Block
            className={_utils.cx(_styles, "waves---center-heading-6")}
            tag="div"
          >
            <_Builtin.Heading
              className={_utils.cx(_styles, "waves---heading-2-no-margins-11")}
              tag="h2"
            >
              {"In the press"}
            </_Builtin.Heading>
          </_Builtin.Block>
          <_Builtin.Block
            className={_utils.cx(_styles, "waves-master-logos-5")}
            tag="div"
          >
            <_Builtin.Link
              className={_utils.cx(_styles, "link-block-21")}
              button={false}
              block="inline"
              options={{
                href: "https://www.complex.com/music/mixed-by-ali-engineears-investors-kendrick-khaled",
                target: "_blank",
              }}
            >
              <_Builtin.Image
                className={_utils.cx(_styles, "waves-image-logo-5")}
                loading="lazy"
                width="auto"
                height="auto"
                alt=""
                src="https://cdn.prod.website-files.com/6356e5735110b93b46145859/67465457f43e1c4826631607_Complex.svg"
              />
            </_Builtin.Link>
            <_Builtin.Link
              className={_utils.cx(_styles, "link-block-21")}
              button={false}
              block="inline"
              options={{
                href: "https://www.forbes.com/sites/afdhelaziz/2021/08/16/how-engineears-is-giving-new-opportunities-to-audio-engineers-around-the-world-with-a-little-help-from-kendrick-lamar-and-dj-khaled/?sh=7f5f0ff95e9b",
                target: "_blank",
              }}
            >
              <_Builtin.Image
                className={_utils.cx(_styles, "waves-image-logo-5")}
                loading="lazy"
                width="auto"
                height="auto"
                alt=""
                src="https://cdn.prod.website-files.com/6356e5735110b93b46145859/674654576b545dcf0db19469_Forbes.svg"
              />
            </_Builtin.Link>
            <_Builtin.Link
              className={_utils.cx(_styles, "link-block-21")}
              button={false}
              block="inline"
              options={{
                href: "https://techcrunch.com/2021/05/05/music-mixing-marketplace-engineears-raises-1m-with-help-from-kendrick-lamar/",
                target: "_blank",
              }}
            >
              <_Builtin.Image
                className={_utils.cx(_styles, "waves-image-logo-5")}
                loading="lazy"
                width="auto"
                height="auto"
                alt=""
                src="https://cdn.prod.website-files.com/6356e5735110b93b46145859/67465457bca30ada45807dc6_TechCrunch.svg"
              />
            </_Builtin.Link>
            <_Builtin.Link
              className={_utils.cx(_styles, "link-block-21")}
              button={false}
              block="inline"
              options={{
                href: "https://www.billboard.com/music/rb-hip-hop/mixedbyali-engine-ears-investors-exclusive-9567193/",
                target: "_blank",
              }}
            >
              <_Builtin.Image
                className={_utils.cx(_styles, "waves-image-logo-5")}
                loading="lazy"
                width="auto"
                height="auto"
                alt=""
                src="https://cdn.prod.website-files.com/6356e5735110b93b46145859/674654577abc37a1baf16559_Billboard.svg"
              />
            </_Builtin.Link>
            <_Builtin.Link
              className={_utils.cx(_styles, "link-block-21")}
              button={false}
              block="inline"
              options={{
                href: "https://variety.com/2021/music/news/dolby-laboratories-derek-mixed-by-ali-engine-ears-1235103614/",
                target: "_blank",
              }}
            >
              <_Builtin.Image
                className={_utils.cx(_styles, "waves-image-logo-5")}
                loading="lazy"
                width="auto"
                height="auto"
                alt=""
                src="https://cdn.prod.website-files.com/6356e5735110b93b46145859/67465457417f87144ffc7ce1_Variety.svg"
              />
            </_Builtin.Link>
          </_Builtin.Block>
        </_Builtin.Container>
      </_Builtin.Section>
    </_Component>
  );
}
